// Translations for Daily 1 App
// Languages: German (de), English (en), Bosnian (bs)

export const translations = {
  de: {
    // App header
    appName: "Daily 1",
    ramadanTitle: "Dein Ramadan",
    blessedNights: "{count} Nächte Segen",
    ramadanFooter: "Jede kleine Tat zählt – besonders im Ramadan.",
    afterIftarText: "Der Durst ist vergangen, die Adern befeuchtet und die Belohnung steht fest, so Allah will.",
    lailatulQadrText: "Eine Nacht besser als tausend Monate.",
    lailatulQadrSource: "— Sure 97:3",
    
    // Notifications
    dailyReminder: "Tägliche Erinnerung",
    reminderQuestion: "Möchtest du jeden Morgen um 6 Uhr an deine gute Tat erinnert werden?",
    yesRemindMe: "Ja, erinnere mich",
    later: "Später",
    notificationsEnabled: "Benachrichtigungen aktiviert!",
    notificationsEnabledDesc: "Du erhältst täglich eine Erinnerung an deine gute Tat.",
    notificationsDisabled: "Benachrichtigungen deaktiviert",
    notificationsDisabledDesc: "Du erhältst keine Push-Nachrichten mehr.",
    permissionDenied: "Berechtigung verweigert",
    permissionDeniedDesc: "Bitte erlaube Benachrichtigungen in den Browser-Einstellungen.",
    enableError: "Fehler beim Aktivieren",
    enableErrorDesc: "Bitte versuche es erneut.",
    disableNotifications: "Benachrichtigungen deaktivieren",
    enableNotifications: "Tägliche Erinnerung aktivieren",
    
    // Ramadan
    ramadanDay: "Tag {day} von 30",
    ramadanModeActive: "Ramadan-Modus automatisch aktiv",
    ramadanModeDisable: "Ramadan-Modus deaktivieren",
    ramadanModeEnable: "Ramadan-Modus aktivieren",
    ramadanMubarak: "Ramadan Mubarak!",
    ramadanMubarakDesc: "Ramadan-Modus aktiviert. Möge Allah dein Fasten annehmen.",
    ramadanModeDeactivated: "Ramadan-Modus deaktiviert",
    ramadanModeDeactivatedDesc: "Normale Tages-Taten wieder aktiv.",
    
    // Deed card
    completed: "Geschafft! ✨",
    markComplete: "Erledigt",
    alreadyCompleted: "Bereits erledigt",
    markAsComplete: "Als erledigt markieren",
    todaysDeed: "Deine gute Tat für heute",
    
    // Personalized greeting
    greeting: "Salamu Alaikum",
    
    // Success messages
    successRamadan: "Möge Allah es annehmen!",
    successNormal: "Großartig! Du hast heute Gutes getan.",
    deedSaved: "Deine gute Tat wurde gespeichert.",
    deedSavedNotification: "Deine gute Tat wurde über die Benachrichtigung gespeichert.",
    
    // Stats
    startToday: "Starte heute!",
    completedDeeds: "erledigte Taten",
    firstDeed: "Erste Tat!",
    goodDeeds: "Gute Taten",
    nextDeed: "Nächste Tat",
    nextDeedIn: "Deine nächste gute Tat kommt in...",
    currentStreak: "Serie",
    
    // Badges
    badge7Days: "7 Tage",
    badge30Days: "30 Tage",
    badge100Deeds: "100 Taten",
    
    // Share
    share: "Teilen & Inspirieren",
    shareSubtext: "Teile diese Erinnerung",
    shareTitle: "Daily 1",
    shareText: `✨ Eine schöne tägliche Erinnerung:

„{deed}"

Eine App. Eine Tat. Jeden Tag.
Mach mit – es dauert nur eine Minute! 💚

▶ Jetzt laden: https://apps.apple.com/app/id6757438087`,
    shareSuccess: "Geteilt!",
    shareSuccessDesc: "Danke fürs Inspirieren.",
    textCopied: "Kopiert!",
    textCopiedDesc: "Bereit zum Teilen.",
    
    // History
    last10Days: "Letzte 10 Tage",
    showMore: "Mehr anzeigen",
    showLess: "Weniger anzeigen",
    streakDays: "Tage Serie",
    yourPath: "Dein Fortschritt",
    yourProgress: "Dein Weg zu einem besseren Muslim",
    yourProgressFemale: "Dein Weg zu einer besseren Muslima",
    
    // Footer
    footerRamadan: "Möge Allah dein Fasten und deine guten Taten annehmen.",
    footerNormal: "«Die besten Taten vor Allah sind die, die regelmäßig getan werden, auch wenn sie klein sind.»",
    footerSource: "— Sahih al-Bukhari 6465, Sahih Muslim 783",
    
    // Swipe Carousel
    swipeHint: "Wische für weitere Taten",
    selectDeed: "Diese Tat wählen",
    chooseDeed: "Wähle deine Tat für heute",
    changeDeed: "Andere Tat",
    confirmDeed: "Tat bestätigen",
    
    // Language
    selectLanguage: "Sprache wählen",
    
    // Push Notifications
    pushTitle: "🌱 Daily 1",
    pushBody: "Deine gute Tat für heute wartet auf dich!",
    
    // iOS specific notifications
    iosNotificationsNote: "Bitte aktiviere Mitteilungen in: Einstellungen → Daily 1 → Mitteilungen",
    iosPermissionDenied: "Berechtigung benötigt",
    iosPermissionDeniedDesc: "Bitte aktiviere Mitteilungen in: Einstellungen → Daily 1 → Mitteilungen",
    iosNotificationsEnabled: "Push-Benachrichtigungen sind jetzt aktiv!",
    iosSafariNotSupported: "Push in Safari nicht verfügbar",
    iosSafariInstallPWA: "Für Push-Benachrichtigungen: Teilen → 'Zum Home-Bildschirm' oder nutze die TestFlight App.",
    
    // Review Prompt
    reviewTitle: "Gefällt dir Daily 1?",
    reviewSubtext: "Eine kurze Bewertung unterstützt dieses kostenlose Projekt 🤍",
    reviewButton: "App bewerten",
    reviewLater: "Später",
    reviewNever: "Nicht mehr fragen",
    
    // Post-Deed Modal (Dua)
    postDeedGift: "Dass du diese Tat tun konntest, ist ein Geschenk von Allah.",
    postDeedDua: "O Allah, nimm es von mir an.",
    postDeedTitle: "Masha'Allah!",
    postDeedMessage: "Möge Allah es von dir annehmen. Morgen gibt es eine weitere Gelegenheit, um zu wachsen – sei gespannt!",
    postDeedContinue: "Weiter",
    postDeedOptionsTitle: "Was möchtest du tun?",
    postDeedAddThoughts: "Gedanken hinzufügen",
    postDeedViewMilestones: "Meilensteine ansehen",
    postDeedSkip: "Überspringen",
    postDeedFeelingsTitle: "Wie fühlst du dich nach diesem Deed?",
    feelingMotivated: "Motiviert & bereit für mehr 💪",
    feelingGrateful: "Dankbar für das Geschaffte 🙏",
    feelingSatisfied: "Etwas müde, aber zufrieden 😌",
    feelingExcited: "Lust auf den nächsten Deed 🚀",
    feelingEnough: "Heute reichte es – morgen wieder!",
    feelingThanks: "Danke fürs Teilen! 💚",
    postDeedMilestonesTitle: "Deine Meilensteine",
    postDeedDone: "Fertig",
    
    // Intention (Post-Deed)
    intentionQuestion: "Mit welcher Absicht hast du diese Tat getan?",
    intentionForAllah: "Ich habe sie bewusst für Allah getan",
    intentionEffort: "Ich habe mich bemüht, auch wenn es schwer war",
    intentionHumble: "Ich habe sie still und ohne Erwartung getan",
    intentionHope: "Ich hoffe, dass Allah sie annimmt",
    confirmationPure: "Die reine Absicht verleiht der Tat Gewicht.",
    confirmationEffort: "Auch ein kleines Bemühen ist wertvoll.",
    confirmationSeen: "Allah sieht, was in deinem Herzen ist.",
    reflectionTitle: "REFLEXION",
    
    // Category Focus (Premium)
    categoryFocusTitle: "Dein Schwerpunkt",
    categoryFocusSubtext: "Wähle eine Kategorie für fokussierte Taten",
    categoryAll: "Alle Kategorien",
    categoryFocusActive: "Aktiv",
    changeFocus: "Schwerpunkt ändern",
    
    // Context Filter / Deine Situation
    yourSituation: "Deine Situation",
    contextFilter: "Deine Situation",
    contextFilterTitle: "Deine Situation",
    contextFilterSubtitle: "Wähle Situationen für individuelle Taten",
    contextFilterHint: "Mehrfachauswahl möglich",
    contextFilterApply: "Anwenden",
    contextFilterReset: "Zurücksetzen",
    contextFilterActive: "Aktive Filter",
    
    // Feedback Modal
    feedback: "Feedback",
    feedbackTitle: "Feedback",
    feedbackFeatureTitle: "Verbesserungsvorschläge sind sehr willkommen.",
    feedbackFeatureButton: "Feature-Wunsch senden",
    feedbackFeaturePlaceholder: "Beschreibe deine Idee...",
    feedbackContactTitle: "Du hast einen Fehler gefunden oder konstruktive Kritik?",
    feedbackContactButton: "Schreib uns",
    feedbackSent: "Danke für dein Feedback!",
    feedbackClose: "Schließen",
    
    // Footer links
    privacyPolicy: "Datenschutz",
    support: "Support",
    privacyUrl: "/privacy-de.html",
    supportUrl: "/support-de.html",
  },
  
  en: {
    // App header
    appName: "Daily 1",
    ramadanTitle: "Your Ramadan",
    blessedNights: "{count} Blessed Nights",
    ramadanFooter: "Every small deed counts – especially in Ramadan.",
    afterIftarText: "The thirst has gone, the veins are moistened, and the reward is assured, if Allah wills.",
    lailatulQadrText: "A night better than a thousand months.",
    lailatulQadrSource: "— Surah 97:3",
    
    // Notifications
    dailyReminder: "Daily Reminder",
    reminderQuestion: "Would you like to be reminded of your good deed every morning at 6 AM?",
    yesRemindMe: "Yes, remind me",
    later: "Later",
    notificationsEnabled: "Notifications enabled!",
    notificationsEnabledDesc: "You will receive a daily reminder for your good deed.",
    notificationsDisabled: "Notifications disabled",
    notificationsDisabledDesc: "You will no longer receive push notifications.",
    permissionDenied: "Permission denied",
    permissionDeniedDesc: "Please allow notifications in your browser settings.",
    enableError: "Error enabling",
    enableErrorDesc: "Please try again.",
    disableNotifications: "Disable notifications",
    enableNotifications: "Enable daily reminder",
    
    // Ramadan
    ramadanDay: "Day {day} of 30",
    ramadanModeActive: "Ramadan mode automatically active",
    ramadanModeDisable: "Disable Ramadan mode",
    ramadanModeEnable: "Enable Ramadan mode",
    ramadanMubarak: "Ramadan Mubarak!",
    ramadanMubarakDesc: "Ramadan mode activated. May Allah accept your fasting.",
    ramadanModeDeactivated: "Ramadan mode deactivated",
    ramadanModeDeactivatedDesc: "Regular daily deeds are active again.",
    
    // Deed card
    completed: "Done! ✨",
    markComplete: "Done",
    alreadyCompleted: "Already completed",
    markAsComplete: "Mark as complete",
    todaysDeed: "Your good deed for today",
    
    // Personalized greeting
    greeting: "Salamu Alaikum",
    
    // Success messages
    successRamadan: "May Allah accept it!",
    successNormal: "Great! You did something good today.",
    deedSaved: "Your good deed has been saved.",
    deedSavedNotification: "Your good deed was saved via the notification.",
    
    // Stats
    startToday: "Start today!",
    completedDeeds: "completed deeds",
    firstDeed: "First deed!",
    goodDeeds: "Good Deeds",
    nextDeed: "Next Deed",
    nextDeedIn: "Your next good deed comes in...",
    currentStreak: "Current Streak",
    
    // Badges
    badge7Days: "7 Days",
    badge30Days: "30 Days",
    badge100Deeds: "100 Deeds",
    
    // Share
    share: "Share & Inspire",
    shareSubtext: "Share this reminder",
    shareTitle: "Daily 1",
    shareText: `✨ A beautiful daily reminder:

"{deed}"

One app. One deed. Every day.
Join in – it only takes a minute! 💚

▶ Download now: https://apps.apple.com/app/id6757438087`,
    shareSuccess: "Shared!",
    shareSuccessDesc: "Thanks for inspiring others.",
    textCopied: "Copied!",
    textCopiedDesc: "Ready to share.",
    
    // History
    last10Days: "Last 10 Days",
    showMore: "Show more",
    showLess: "Show less",
    yourPath: "Your Path",
    yourProgress: "Your Path to Becoming a Better Muslim",
    yourProgressFemale: "Your Path to Becoming a Better Muslimah",
    streakDays: "Days of Consistency",
    
    // Footer
    footerRamadan: "May Allah accept your fasting and good deeds.",
    footerNormal: "\"The best deeds before Allah are those done regularly, even if they are small.\"",
    footerSource: "— Sahih al-Bukhari 6465, Sahih Muslim 783",
    
    // Swipe Carousel
    swipeHint: "Swipe for more deeds",
    selectDeed: "Choose this deed",
    chooseDeed: "Choose your deed for today",
    changeDeed: "Change deed",
    confirmDeed: "Confirm deed",
    
    // Language
    selectLanguage: "Select language",
    
    // Push Notifications
    pushTitle: "🌱 Daily 1",
    pushBody: "Your good deed for today is waiting for you!",
    
    // iOS specific notifications
    iosNotificationsNote: "Please enable notifications in: Settings → Daily 1 → Notifications",
    iosPermissionDenied: "Permission required",
    iosPermissionDeniedDesc: "Please enable notifications in: Settings → Daily 1 → Notifications",
    iosNotificationsEnabled: "Push notifications are now active!",
    iosSafariNotSupported: "Push not available in Safari",
    iosSafariInstallPWA: "For push notifications: Share → 'Add to Home Screen' or use the TestFlight app.",
    
    // Review Prompt
    reviewTitle: "Do you like Daily 1?",
    reviewSubtext: "A short review supports this free project 🤍",
    reviewButton: "Rate App",
    reviewLater: "Later",
    reviewNever: "Don't ask again",
    
    // Post-Deed Modal (Dua)
    postDeedGift: "Being able to do this deed is a gift from Allah.",
    postDeedDua: "O Allah, accept it from me.",
    postDeedTitle: "Masha'Allah!",
    postDeedMessage: "May Allah accept it from you. Tomorrow brings another opportunity to grow – stay tuned!",
    postDeedContinue: "Continue",
    postDeedOptionsTitle: "What would you like to do?",
    postDeedAddThoughts: "Add thoughts",
    postDeedViewMilestones: "View milestones",
    postDeedSkip: "Skip",
    postDeedFeelingsTitle: "How do you feel after this deed?",
    feelingMotivated: "Motivated & ready for more 💪",
    feelingGrateful: "Grateful for what I achieved 🙏",
    feelingSatisfied: "A bit tired, but satisfied 😌",
    feelingExcited: "Excited for the next deed 🚀",
    feelingEnough: "That was enough for today – see you tomorrow!",
    feelingThanks: "Thanks for sharing! 💚",
    postDeedMilestonesTitle: "Your Milestones",
    postDeedDone: "Done",
    
    // Intention (Post-Deed)
    intentionQuestion: "With what intention did you do this deed?",
    intentionForAllah: "I did it consciously for Allah",
    intentionEffort: "I made an effort, even though it was hard",
    intentionHumble: "I did it quietly and without expectation",
    intentionHope: "I hope that Allah accepts it",
    confirmationPure: "A pure intention gives weight to the deed.",
    confirmationEffort: "Even a small effort is valuable.",
    confirmationSeen: "Allah sees what is in your heart.",
    reflectionTitle: "REFLECTION",
    
    // Category Focus (Premium)
    categoryFocusTitle: "Your Focus",
    categoryFocusSubtext: "Choose a category for focused deeds",
    categoryAll: "All Categories",
    categoryFocusActive: "Active",
    changeFocus: "Change Focus",
    
    // Feedback Modal
    feedback: "Feedback",
    feedbackTitle: "Feedback",
    feedbackFeatureTitle: "Any suggestions for improvements are highly appreciated.",
    feedbackFeatureButton: "Send Feature Request",
    feedbackFeaturePlaceholder: "Describe your idea...",
    feedbackContactTitle: "You found an error or have constructive criticism?",
    feedbackContactButton: "Write us",
    feedbackSent: "Thank you for your feedback!",
    feedbackClose: "Close",
    
    // Footer links
    privacyPolicy: "Privacy",
    support: "Support",
    privacyUrl: "/privacy.html",
    supportUrl: "/support.html",
  },
  
  bs: {
    // App header
    appName: "Daily 1",
    ramadanTitle: "Tvoj Ramazan",
    blessedNights: "{count} Noći Bereketa",
    ramadanFooter: "Svako malo djelo se računa – posebno u Ramazanu.",
    afterIftarText: "Žeđ je prošla, vene su se navlažile i nagrada je osigurana, ako Allah da.",
    lailatulQadrText: "Noć bolja od hiljadu mjeseci.",
    lailatulQadrSource: "— Sura 97:3",
    
    // Notifications
    dailyReminder: "Dnevni Podsjetnik",
    reminderQuestion: "Želiš li da te svako jutro u 6 sati podsjetimo na tvoje dobro djelo?",
    yesRemindMe: "Da, podsjeti me",
    later: "Kasnije",
    notificationsEnabled: "Obavijesti uključene!",
    notificationsEnabledDesc: "Primit ćeš dnevni podsjetnik za svoje dobro djelo.",
    notificationsDisabled: "Obavijesti isključene",
    notificationsDisabledDesc: "Više nećeš primati push obavijesti.",
    permissionDenied: "Dozvola odbijena",
    permissionDeniedDesc: "Molimo dozvoli obavijesti u postavkama preglednika.",
    enableError: "Greška pri uključivanju",
    enableErrorDesc: "Molimo pokušaj ponovo.",
    disableNotifications: "Isključi obavijesti",
    enableNotifications: "Uključi dnevni podsjetnik",
    
    // Ramadan
    ramadanDay: "Dan {day} od 30",
    ramadanModeActive: "Ramazan mod automatski aktivan",
    ramadanModeDisable: "Isključi Ramazan mod",
    ramadanModeEnable: "Uključi Ramazan mod",
    ramadanMubarak: "Ramazan Mubarek!",
    ramadanMubarakDesc: "Ramazan mod aktiviran. Allah ti primio post.",
    ramadanModeDeactivated: "Ramazan mod isključen",
    ramadanModeDeactivatedDesc: "Redovna dnevna dobra djela su ponovo aktivna.",
    
    // Deed card
    completed: "Završeno! ✨",
    markComplete: "Završeno",
    alreadyCompleted: "Već završeno",
    markAsComplete: "Označi kao završeno",
    todaysDeed: "Tvoje dobro djelo za danas",
    
    // Personalized greeting
    greeting: "Selam Alejkum",
    
    // Success messages
    successRamadan: "Allah ti primio!",
    successNormal: "Odlično! Danas si učinio/la nešto dobro.",
    deedSaved: "Tvoje dobro djelo je sačuvano.",
    deedSavedNotification: "Tvoje dobro djelo je sačuvano putem obavijesti.",
    
    // Stats
    startToday: "Počni danas!",
    completedDeeds: "završenih djela",
    firstDeed: "Prvo djelo!",
    goodDeeds: "Dobra Djela",
    nextDeed: "Sljedeće Djelo",
    nextDeedIn: "Tvoje sljedeće dobro djelo dolazi za...",
    currentStreak: "Trenutna serija",
    
    // Badges
    badge7Days: "7 Dana",
    badge30Days: "30 Dana",
    badge100Deeds: "100 Djela",
    
    // Share
    share: "Podijeli & Inspiriši",
    shareSubtext: "Podijeli ovaj podsjetnik",
    shareTitle: "Daily 1",
    shareText: `✨ Lijep dnevni podsjetnik:

„{deed}"

Jedna aplikacija. Jedno djelo. Svaki dan.
Pridruži se – traje samo minutu! 💚

▶ Preuzmi: https://apps.apple.com/app/id6757438087`,
    shareSuccess: "Podijeljeno!",
    shareSuccessDesc: "Hvala što inspirišeš druge.",
    textCopied: "Kopirano!",
    textCopiedDesc: "Spremno za dijeljenje.",
    
    // History
    last10Days: "Zadnjih 10 dana",
    showMore: "Prikaži više",
    showLess: "Prikaži manje",
    yourPath: "Tvoj put",
    yourProgress: "Tvoj put ka boljem muslimanu",
    yourProgressFemale: "Tvoj put ka boljoj muslimanki",
    streakDays: "Dana dosljednosti",
    
    // Footer
    footerRamadan: "Allah ti primio post i dobra djela.",
    footerNormal: "«Najbolja djela kod Allaha su ona koja se redovno čine, makar bila i mala.»",
    footerSource: "— Sahih al-Bukhari 6465, Sahih Muslim 783",
    
    // Swipe Carousel
    swipeHint: "Prevuci za više djela",
    selectDeed: "Odaberi ovo djelo",
    chooseDeed: "Odaberi svoje djelo za danas",
    changeDeed: "Drugo djelo",
    confirmDeed: "Potvrdi djelo",
    
    // Language
    selectLanguage: "Odaberi jezik",
    
    // Push Notifications
    pushTitle: "🌱 Daily 1",
    pushBody: "Tvoje dobro djelo za danas te čeka!",
    
    // iOS specific notifications
    iosNotificationsNote: "Molimo aktiviraj obavijesti u: Postavke → Daily 1 → Obavijesti",
    iosPermissionDenied: "Potrebna dozvola",
    iosPermissionDeniedDesc: "Molimo aktiviraj obavijesti u: Postavke → Daily 1 → Obavijesti",
    iosNotificationsEnabled: "Push obavijesti su sada aktivne!",
    iosSafariNotSupported: "Push nije dostupan u Safariju",
    iosSafariInstallPWA: "Za push obavijesti: Dijeli → 'Dodaj na početni ekran' ili koristi TestFlight aplikaciju.",
    
    // Review Prompt
    reviewTitle: "Sviđa ti se Daily 1?",
    reviewSubtext: "Kratka ocjena podržava ovaj besplatni projekat 🤍",
    reviewButton: "Ocijeni aplikaciju",
    reviewLater: "Kasnije",
    reviewNever: "Ne pitaj više",
    
    // Post-Deed Modal (Dua) - Gender specific
    postDeedGift: "To što si mogao uraditi ovo djelo je dar od Allaha.",
    postDeedGiftFemale: "To što si mogla uraditi ovo djelo je dar od Allaha.",
    postDeedDua: "O Allahu, primi od mene.",
    postDeedTitle: "Mašallah!",
    postDeedMessage: "Allah ti primio. Sutra dolazi nova prilika za rast – budi spreman!",
    postDeedMessageFemale: "Allah ti primio. Sutra dolazi nova prilika za rast – budi spremna!",
    postDeedContinue: "Nastavi",
    postDeedOptionsTitle: "Šta želiš uraditi?",
    postDeedAddThoughts: "Dodaj misli",
    postDeedViewMilestones: "Pogledaj dostignuća",
    postDeedSkip: "Preskoči",
    postDeedFeelingsTitle: "Kako se osjećaš nakon ovog djela?",
    feelingMotivated: "Motiviran i spreman za više 💪",
    feelingMotivatedFemale: "Motivirana i spremna za više 💪",
    feelingGrateful: "Zahvalan za postignuto 🙏",
    feelingGratefulFemale: "Zahvalna za postignuto 🙏",
    feelingSatisfied: "Malo umoran, ali zadovoljan 😌",
    feelingSatisfiedFemale: "Malo umorna, ali zadovoljna 😌",
    feelingExcited: "Jedva čekam sljedeće djelo 🚀",
    feelingEnough: "Danas je bilo dovoljno – vidimo se sutra!",
    feelingThanks: "Hvala što dijeliš! 💚",
    postDeedMilestonesTitle: "Tvoja dostignuća",
    postDeedDone: "Gotovo",
    
    // Intention (Post-Deed)
    intentionQuestion: "S kojom nijetom si uradio ovo djelo?",
    intentionQuestionFemale: "S kojom nijetom si uradila ovo djelo?",
    intentionForAllah: "Uradio sam ga svjesno za Allaha",
    intentionForAllahFemale: "Uradila sam ga svjesno za Allaha",
    intentionEffort: "Trudio sam se, iako je bilo teško",
    intentionEffortFemale: "Trudila sam se, iako je bilo teško",
    intentionHumble: "Uradio sam ga tiho i bez očekivanja",
    intentionHumbleFemale: "Uradila sam ga tiho i bez očekivanja",
    intentionHope: "Nadam se da će ga Allah primiti",
    confirmationPure: "Čista nijeta daje težinu djelu.",
    confirmationEffort: "I mali trud je vrijedan.",
    confirmationSeen: "Allah vidi šta je u tvom srcu.",
    reflectionTitle: "REFLEKSIJA",
    
    // Category Focus (Premium)
    categoryFocusTitle: "Tvoj fokus",
    categoryFocusSubtext: "Izaberi kategoriju za fokusirana djela",
    categoryAll: "Sve kategorije",
    categoryFocusActive: "Aktivno",
    changeFocus: "Promijeni fokus",
    
    // Feedback Modal
    feedback: "Povratna informacija",
    feedbackTitle: "Povratna informacija",
    feedbackFeatureTitle: "Prijedlozi za poboljšanja su dobrodošli.",
    feedbackFeatureButton: "Pošalji prijedlog",
    feedbackFeaturePlaceholder: "Opiši svoju ideju...",
    feedbackContactTitle: "Pronašao si grešku ili imaš konstruktivnu kritiku?",
    feedbackContactButton: "Piši nam",
    feedbackSent: "Hvala na povratnoj informaciji!",
    feedbackClose: "Zatvori",
    
    // Footer links
    privacyPolicy: "Privatnost",
    support: "Podrška",
    privacyUrl: "/privacy-bs.html",
    supportUrl: "/support-bs.html",
  },

  // Arabic - العربية
  ar: {
    // App header
    appName: "Daily 1",
    ramadanTitle: "رمضانك",
    blessedNights: "{count} ليالي مباركة",
    ramadanFooter: "كل عمل صغير يُحتسب – خاصة في رمضان.",
    afterIftarText: "ذهب الظمأ وابتلّت العروق وثبت الأجر إن شاء الله.",
    lailatulQadrText: "ليلة خير من ألف شهر.",
    lailatulQadrSource: "— سورة القدر ٣",
    
    // Notifications
    dailyReminder: "التذكير اليومي",
    reminderQuestion: "هل تريد أن نذكرك بعملك الصالح كل صباح الساعة 6؟",
    yesRemindMe: "نعم، ذكرني",
    later: "لاحقاً",
    notificationsEnabled: "تم تفعيل الإشعارات!",
    notificationsEnabledDesc: "ستتلقى تذكيراً يومياً بعملك الصالح.",
    notificationsDisabled: "تم إيقاف الإشعارات",
    notificationsDisabledDesc: "لن تتلقى إشعارات بعد الآن.",
    permissionDenied: "تم رفض الإذن",
    permissionDeniedDesc: "يرجى السماح بالإشعارات في إعدادات المتصفح.",
    enableError: "خطأ في التفعيل",
    enableErrorDesc: "يرجى المحاولة مرة أخرى.",
    disableNotifications: "إيقاف الإشعارات",
    enableNotifications: "تفعيل التذكير اليومي",
    
    // Ramadan
    ramadanDay: "اليوم {day} من 30",
    ramadanModeActive: "وضع رمضان نشط تلقائياً",
    ramadanModeDisable: "إيقاف وضع رمضان",
    ramadanModeEnable: "تفعيل وضع رمضان",
    ramadanMubarak: "رمضان مبارك!",
    ramadanMubarakDesc: "تم تفعيل وضع رمضان. تقبل الله صيامك.",
    ramadanModeDeactivated: "تم إيقاف وضع رمضان",
    ramadanModeDeactivatedDesc: "الأعمال الصالحة اليومية نشطة مرة أخرى.",
    
    // Deed card
    completed: "تم! ✨",
    markComplete: "تم",
    alreadyCompleted: "تم إنجازه",
    markAsComplete: "تحديد كمكتمل",
    todaysDeed: "عملك الصالح لهذا اليوم",
    
    // Personalized greeting
    greeting: "السلام عليكم",
    
    // Success messages
    successRamadan: "تقبل الله!",
    successNormal: "أحسنت! فعلت شيئاً جيداً اليوم.",
    deedSaved: "تم حفظ عملك الصالح.",
    deedSavedNotification: "تم حفظ عملك الصالح عبر الإشعار.",
    
    // Stats
    startToday: "ابدأ اليوم!",
    completedDeeds: "أعمال مكتملة",
    firstDeed: "أول عمل!",
    goodDeeds: "الأعمال الصالحة",
    nextDeed: "العمل التالي",
    nextDeedIn: "عملك الصالح التالي بعد...",
    currentStreak: "السلسلة الحالية",
    
    // Badges
    badge7Days: "7 أيام",
    badge30Days: "30 يوم",
    badge100Deeds: "100 عمل",
    
    // Share
    share: "شارك وألهم",
    shareSubtext: "شارك هذا التذكير",
    shareTitle: "Daily 1",
    shareText: `✨ تذكير يومي جميل:

"{deed}"

تطبيق واحد. عمل واحد. كل يوم.
انضم – يستغرق دقيقة واحدة فقط! 💚

▶ حمّل الآن: https://apps.apple.com/app/id6757438087`,
    shareSuccess: "تم المشاركة!",
    shareSuccessDesc: "شكراً لإلهامك الآخرين.",
    textCopied: "تم النسخ!",
    textCopiedDesc: "جاهز للمشاركة.",
    
    // History
    last10Days: "آخر 10 أيام",
    showMore: "عرض المزيد",
    showLess: "عرض أقل",
    yourPath: "طريقك",
    yourProgress: "طريقك لتصبح مسلماً أفضل",
    yourProgressFemale: "طريقك لتصبحي مسلمة أفضل",
    streakDays: "أيام من الثبات",
    
    // Footer
    footerRamadan: "تقبل الله صيامك وأعمالك الصالحة.",
    footerNormal: "«أحب الأعمال إلى الله أدومها وإن قل.»",
    footerSource: "— صحيح البخاري 6465، صحيح مسلم 783",
    
    // Swipe Carousel
    swipeHint: "اسحب للمزيد من الأعمال",
    selectDeed: "اختر هذا العمل",
    chooseDeed: "اختر عملك الصالح لهذا اليوم",
    changeDeed: "عمل آخر",
    confirmDeed: "تأكيد العمل",
    
    // Language
    selectLanguage: "اختر اللغة",
    
    // Push Notifications
    pushTitle: "🌱 Daily 1",
    pushBody: "عملك الصالح لهذا اليوم في انتظارك!",
    
    // iOS specific
    iosNotificationsNote: "يرجى تفعيل الإشعارات في: الإعدادات ← Daily 1 ← الإشعارات",
    iosPermissionDenied: "مطلوب إذن",
    iosPermissionDeniedDesc: "يرجى تفعيل الإشعارات في: الإعدادات ← Daily 1 ← الإشعارات",
    iosNotificationsEnabled: "الإشعارات نشطة الآن!",
    iosSafariNotSupported: "الإشعارات غير متوفرة في Safari",
    iosSafariInstallPWA: "للإشعارات: مشاركة ← 'إضافة إلى الشاشة الرئيسية'",
    
    // Review Prompt
    reviewTitle: "هل تعجبك Daily 1؟",
    reviewSubtext: "تقييم قصير يدعم هذا المشروع المجاني 🤍",
    reviewButton: "قيّم التطبيق",
    reviewLater: "لاحقاً",
    reviewNever: "لا تسأل مرة أخرى",
    
    // Post-Deed Modal (Dua) - Gender specific for Arabic
    postDeedGift: "أن تتمكن من فعل هذا العمل هو نعمة من الله.",
    postDeedGiftFemale: "أن تتمكني من فعل هذا العمل هو نعمة من الله.",
    postDeedDua: "اللهم تقبل مني.",
    postDeedTitle: "ما شاء الله!",
    postDeedMessage: "تقبل الله منك. غداً فرصة جديدة للنمو – كن مستعداً!",
    postDeedMessageFemale: "تقبل الله منك. غداً فرصة جديدة للنمو – كوني مستعدة!",
    postDeedContinue: "متابعة",
    postDeedOptionsTitle: "ماذا تريد أن تفعل؟",
    postDeedAddThoughts: "أضف أفكارك",
    postDeedViewMilestones: "عرض الإنجازات",
    postDeedSkip: "تخطي",
    postDeedFeelingsTitle: "كيف تشعر بعد هذا العمل؟",
    feelingMotivated: "متحمس ومستعد للمزيد 💪",
    feelingMotivatedFemale: "متحمسة ومستعدة للمزيد 💪",
    feelingGrateful: "ممتن لما أنجزته 🙏",
    feelingGratefulFemale: "ممتنة لما أنجزته 🙏",
    feelingSatisfied: "متعب قليلاً لكن راضٍ 😌",
    feelingSatisfiedFemale: "متعبة قليلاً لكن راضية 😌",
    feelingExcited: "متشوق للعمل التالي 🚀",
    feelingEnough: "كان هذا كافياً اليوم – إلى الغد!",
    feelingThanks: "شكراً لمشاركتك! 💚",
    postDeedMilestonesTitle: "إنجازاتك",
    postDeedDone: "تم",
    
    // Intention (Post-Deed)
    intentionQuestion: "بأي نية قمت بهذا العمل؟",
    intentionForAllah: "فعلته بوعي لله",
    intentionEffort: "بذلت جهدي رغم صعوبته",
    intentionHumble: "فعلته بهدوء ودون انتظار شيء",
    intentionHope: "أرجو أن يتقبله الله",
    confirmationPure: "النية الخالصة تعطي ثقلاً للعمل.",
    confirmationEffort: "حتى الجهد الصغير له قيمة.",
    confirmationSeen: "الله يرى ما في قلبك.",
    reflectionTitle: "تَأَمُّل",
    
    // Category Focus (Premium)
    categoryFocusTitle: "تركيزك",
    categoryFocusSubtext: "اختر فئة للأعمال المركزة",
    categoryAll: "جميع الفئات",
    categoryFocusActive: "نشط",
    changeFocus: "تغيير التركيز",
    
    // Feedback Modal
    feedback: "ملاحظات",
    feedbackTitle: "ملاحظات",
    feedbackFeatureTitle: "اقتراحات التحسين مرحب بها.",
    feedbackFeatureButton: "إرسال طلب ميزة",
    feedbackFeaturePlaceholder: "صف فكرتك...",
    feedbackContactTitle: "وجدت خطأ أو لديك نقد بناء؟",
    feedbackContactButton: "راسلنا",
    feedbackSent: "شكراً على ملاحظاتك!",
    feedbackClose: "إغلاق",
    
    // Footer links
    privacyPolicy: "الخصوصية",
    support: "الدعم",
    privacyUrl: "/privacy.html",
    supportUrl: "/support.html",
  },

  // Indonesian - Bahasa Indonesia
  id: {
    // App header
    appName: "Daily 1",
    ramadanTitle: "Ramadanmu",
    blessedNights: "{count} Malam Berkah",
    ramadanFooter: "Setiap amal kecil dihitung – terutama di Ramadan.",
    afterIftarText: "Dahaga telah hilang, urat nadi telah basah, dan pahala telah ditetapkan, insya Allah.",
    lailatulQadrText: "Satu malam lebih baik dari seribu bulan.",
    lailatulQadrSource: "— Surah 97:3",
    
    // Notifications
    dailyReminder: "Pengingat Harian",
    reminderQuestion: "Apakah kamu ingin diingatkan tentang amal baikmu setiap pagi pukul 6?",
    yesRemindMe: "Ya, ingatkan saya",
    later: "Nanti",
    notificationsEnabled: "Notifikasi aktif!",
    notificationsEnabledDesc: "Kamu akan menerima pengingat harian untuk amal baikmu.",
    notificationsDisabled: "Notifikasi dinonaktifkan",
    notificationsDisabledDesc: "Kamu tidak akan menerima notifikasi lagi.",
    permissionDenied: "Izin ditolak",
    permissionDeniedDesc: "Silakan izinkan notifikasi di pengaturan browser.",
    enableError: "Gagal mengaktifkan",
    enableErrorDesc: "Silakan coba lagi.",
    disableNotifications: "Nonaktifkan notifikasi",
    enableNotifications: "Aktifkan pengingat harian",
    
    // Ramadan
    ramadanDay: "Hari {day} dari 30",
    ramadanModeActive: "Mode Ramadan aktif otomatis",
    ramadanModeDisable: "Nonaktifkan mode Ramadan",
    ramadanModeEnable: "Aktifkan mode Ramadan",
    ramadanMubarak: "Ramadan Mubarak!",
    ramadanMubarakDesc: "Mode Ramadan diaktifkan. Semoga Allah menerima puasamu.",
    ramadanModeDeactivated: "Mode Ramadan dinonaktifkan",
    ramadanModeDeactivatedDesc: "Amal baik harian aktif kembali.",
    
    // Deed card
    completed: "Selesai! ✨",
    markComplete: "Selesai",
    alreadyCompleted: "Sudah selesai",
    markAsComplete: "Tandai selesai",
    todaysDeed: "Amal baikmu hari ini",
    
    // Personalized greeting
    greeting: "Assalamu'alaikum",
    
    // Success messages
    successRamadan: "Semoga Allah menerimanya!",
    successNormal: "Hebat! Kamu telah melakukan sesuatu yang baik hari ini.",
    deedSaved: "Amal baikmu telah disimpan.",
    deedSavedNotification: "Amal baikmu disimpan melalui notifikasi.",
    
    // Stats
    startToday: "Mulai hari ini!",
    completedDeeds: "amal selesai",
    firstDeed: "Amal pertama!",
    goodDeeds: "Amal Baik",
    nextDeed: "Amal Selanjutnya",
    nextDeedIn: "Amal baik selanjutnya dalam...",
    currentStreak: "Streak Saat Ini",
    
    // Badges
    badge7Days: "7 Hari",
    badge30Days: "30 Hari",
    badge100Deeds: "100 Amal",
    
    // Share
    share: "Bagikan & Inspirasi",
    shareSubtext: "Bagikan pengingat ini",
    shareTitle: "Daily 1",
    shareText: `✨ Pengingat harian yang indah:

"{deed}"

Satu aplikasi. Satu amal. Setiap hari.
Bergabunglah – hanya butuh semenit! 💚

▶ Unduh sekarang: https://apps.apple.com/app/id6757438087`,
    shareSuccess: "Dibagikan!",
    shareSuccessDesc: "Terima kasih telah menginspirasi orang lain.",
    textCopied: "Disalin!",
    textCopiedDesc: "Siap dibagikan.",
    
    // History
    last10Days: "10 Hari Terakhir",
    showMore: "Tampilkan lebih",
    showLess: "Tampilkan kurang",
    yourPath: "Jalanmu",
    yourProgress: "Jalanmu Menjadi Muslim yang Lebih Baik",
    yourProgressFemale: "Jalanmu Menjadi Muslimah yang Lebih Baik",
    streakDays: "Hari Konsistensi",
    
    // Footer
    footerRamadan: "Semoga Allah menerima puasa dan amal baikmu.",
    footerNormal: "«Amal yang paling dicintai Allah adalah yang dilakukan secara konsisten, meskipun sedikit.»",
    footerSource: "— Sahih al-Bukhari 6465, Sahih Muslim 783",
    
    // Swipe Carousel
    swipeHint: "Geser untuk amal lainnya",
    selectDeed: "Pilih amal ini",
    chooseDeed: "Pilih amalmu untuk hari ini",
    changeDeed: "Amal lain",
    confirmDeed: "Konfirmasi amal",
    
    // Language
    selectLanguage: "Pilih bahasa",
    
    // Push Notifications
    pushTitle: "🌱 Daily 1",
    pushBody: "Amal baikmu hari ini menunggumu!",
    
    // iOS specific
    iosNotificationsNote: "Silakan aktifkan notifikasi di: Pengaturan → Daily 1 → Notifikasi",
    iosPermissionDenied: "Izin diperlukan",
    iosPermissionDeniedDesc: "Silakan aktifkan notifikasi di: Pengaturan → Daily 1 → Notifikasi",
    iosNotificationsEnabled: "Notifikasi push aktif sekarang!",
    iosSafariNotSupported: "Push tidak tersedia di Safari",
    iosSafariInstallPWA: "Untuk notifikasi: Bagikan → 'Tambah ke Layar Utama'",
    
    // Review Prompt
    reviewTitle: "Suka Daily 1?",
    reviewSubtext: "Ulasan singkat mendukung proyek gratis ini 🤍",
    reviewButton: "Beri Rating",
    reviewLater: "Nanti",
    reviewNever: "Jangan tanya lagi",
    
    // Post-Deed Modal (Dua)
    postDeedGift: "Bisa melakukan amal ini adalah anugerah dari Allah.",
    postDeedDua: "Ya Allah, terimalah dariku.",
    postDeedTitle: "Masha'Allah!",
    postDeedMessage: "Semoga Allah menerimanya darimu. Besok ada kesempatan baru untuk berkembang – nantikan!",
    postDeedContinue: "Lanjut",
    postDeedOptionsTitle: "Apa yang ingin kamu lakukan?",
    postDeedAddThoughts: "Tambah pikiran",
    postDeedViewMilestones: "Lihat pencapaian",
    postDeedSkip: "Lewati",
    postDeedFeelingsTitle: "Bagaimana perasaanmu setelah amal ini?",
    feelingMotivated: "Termotivasi & siap untuk lebih 💪",
    feelingGrateful: "Bersyukur atas yang dicapai 🙏",
    feelingSatisfied: "Agak lelah, tapi puas 😌",
    feelingExcited: "Semangat untuk amal berikutnya 🚀",
    feelingEnough: "Hari ini cukup – sampai besok!",
    feelingThanks: "Terima kasih sudah berbagi! 💚",
    postDeedMilestonesTitle: "Pencapaianmu",
    postDeedDone: "Selesai",
    
    // Intention (Post-Deed)
    intentionQuestion: "Dengan niat apa kamu melakukan amal ini?",
    intentionForAllah: "Saya melakukannya dengan sadar untuk Allah",
    intentionEffort: "Saya berusaha, meskipun sulit",
    intentionHumble: "Saya melakukannya dengan tenang tanpa harapan",
    intentionHope: "Saya berharap Allah menerimanya",
    confirmationPure: "Niat yang tulus memberi bobot pada amal.",
    confirmationEffort: "Usaha kecil pun berharga.",
    confirmationSeen: "Allah melihat apa yang ada di hatimu.",
    reflectionTitle: "REFLEKSI",
    
    // Category Focus (Premium)
    categoryFocusTitle: "Fokusmu",
    categoryFocusSubtext: "Pilih kategori untuk amal yang terfokus",
    categoryAll: "Semua Kategori",
    categoryFocusActive: "Aktif",
    changeFocus: "Ubah Fokus",
    
    // Feedback Modal
    feedback: "Umpan Balik",
    feedbackTitle: "Umpan Balik",
    feedbackFeatureTitle: "Saran perbaikan sangat dihargai.",
    feedbackFeatureButton: "Kirim Permintaan Fitur",
    feedbackFeaturePlaceholder: "Jelaskan idemu...",
    feedbackContactTitle: "Menemukan kesalahan atau punya kritik konstruktif?",
    feedbackContactButton: "Hubungi kami",
    feedbackSent: "Terima kasih atas umpan balikmu!",
    feedbackClose: "Tutup",
    
    // Footer links
    privacyPolicy: "Privasi",
    support: "Dukungan",
    privacyUrl: "/privacy.html",
    supportUrl: "/support.html",
  },

  // Turkish - Türkçe
  tr: {
    // App header
    appName: "Daily 1",
    ramadanTitle: "Senin Ramazanın",
    blessedNights: "{count} Mübarek Gece",
    ramadanFooter: "Her küçük amel sayılır – özellikle Ramazan'da.",
    afterIftarText: "Susuzluk gitti, damarlar ıslandı ve inşallah ecir sabit oldu.",
    lailatulQadrText: "Bin aydan daha hayırlı bir gece.",
    lailatulQadrSource: "— Kadir Suresi 97:3",
    
    // Notifications
    dailyReminder: "Günlük Hatırlatma",
    reminderQuestion: "Her sabah saat 6'da iyi amelin için hatırlatılmak ister misin?",
    yesRemindMe: "Evet, hatırlat",
    later: "Sonra",
    notificationsEnabled: "Bildirimler açık!",
    notificationsEnabledDesc: "İyi amelin için günlük hatırlatma alacaksın.",
    notificationsDisabled: "Bildirimler kapalı",
    notificationsDisabledDesc: "Artık bildirim almayacaksın.",
    permissionDenied: "İzin reddedildi",
    permissionDeniedDesc: "Lütfen tarayıcı ayarlarından bildirimlere izin ver.",
    enableError: "Etkinleştirme hatası",
    enableErrorDesc: "Lütfen tekrar dene.",
    disableNotifications: "Bildirimleri kapat",
    enableNotifications: "Günlük hatırlatmayı aç",
    
    // Ramadan
    ramadanDay: "30'un {day}. Günü",
    ramadanModeActive: "Ramazan modu otomatik aktif",
    ramadanModeDisable: "Ramazan modunu kapat",
    ramadanModeEnable: "Ramazan modunu aç",
    ramadanMubarak: "Ramazan Mübarek!",
    ramadanMubarakDesc: "Ramazan modu aktif. Allah orucunu kabul etsin.",
    ramadanModeDeactivated: "Ramazan modu kapatıldı",
    ramadanModeDeactivatedDesc: "Normal günlük iyilikler tekrar aktif.",
    
    // Deed card
    completed: "Tamam! ✨",
    markComplete: "Tamam",
    alreadyCompleted: "Zaten tamamlandı",
    markAsComplete: "Tamamlandı işaretle",
    todaysDeed: "Bugünkü iyi amelin",
    
    // Personalized greeting
    greeting: "Selamün Aleyküm",
    
    // Success messages
    successRamadan: "Allah kabul etsin!",
    successNormal: "Harika! Bugün iyi bir şey yaptın.",
    deedSaved: "İyi amelin kaydedildi.",
    deedSavedNotification: "İyi amelin bildirim üzerinden kaydedildi.",
    
    // Stats
    startToday: "Bugün başla!",
    completedDeeds: "tamamlanan amel",
    firstDeed: "İlk amel!",
    goodDeeds: "İyi Ameller",
    nextDeed: "Sonraki Amel",
    nextDeedIn: "Sonraki iyi amelin...",
    currentStreak: "Mevcut Seri",
    
    // Badges
    badge7Days: "7 Gün",
    badge30Days: "30 Gün",
    badge100Deeds: "100 Amel",
    
    // Share
    share: "Paylaş ve İlham Ver",
    shareSubtext: "Bu hatırlatmayı paylaş",
    shareTitle: "Daily 1",
    shareText: `✨ Güzel bir günlük hatırlatma:

"{deed}"

Bir uygulama. Bir amel. Her gün.
Katıl – sadece bir dakika sürer! 💚

▶ Şimdi indir: https://apps.apple.com/app/id6757438087`,
    shareSuccess: "Paylaşıldı!",
    shareSuccessDesc: "Başkalarına ilham verdiğin için teşekkürler.",
    textCopied: "Kopyalandı!",
    textCopiedDesc: "Paylaşıma hazır.",
    
    // History
    last10Days: "Son 10 Gün",
    showMore: "Daha fazla göster",
    showLess: "Daha az göster",
    yourPath: "Yolun",
    yourProgress: "Daha İyi Bir Müslüman Olma Yolun",
    yourProgressFemale: "Daha İyi Bir Müslüme Olma Yolun",
    streakDays: "Gün Tutarlılık",
    
    // Footer
    footerRamadan: "Allah orucunu ve iyi amellerini kabul etsin.",
    footerNormal: "«Allah katında en sevimli ameller, az da olsa sürekli yapılanlardır.»",
    footerSource: "— Sahih al-Bukhari 6465, Sahih Muslim 783",
    
    // Swipe Carousel
    swipeHint: "Daha fazla amel için kaydır",
    selectDeed: "Bu ameli seç",
    chooseDeed: "Bugün için amelini seç",
    changeDeed: "Başka amel",
    confirmDeed: "Ameli onayla",
    
    // Language
    selectLanguage: "Dil seç",
    
    // Push Notifications
    pushTitle: "🌱 Daily 1",
    pushBody: "Bugünkü iyi amelin seni bekliyor!",
    
    // iOS specific
    iosNotificationsNote: "Lütfen bildirimleri etkinleştir: Ayarlar → Daily 1 → Bildirimler",
    iosPermissionDenied: "İzin gerekli",
    iosPermissionDeniedDesc: "Lütfen bildirimleri etkinleştir: Ayarlar → Daily 1 → Bildirimler",
    iosNotificationsEnabled: "Push bildirimleri artık aktif!",
    iosSafariNotSupported: "Safari'de push mevcut değil",
    iosSafariInstallPWA: "Bildirimler için: Paylaş → 'Ana Ekrana Ekle'",
    
    // Review Prompt
    reviewTitle: "Daily 1'i beğendin mi?",
    reviewSubtext: "Kısa bir değerlendirme bu ücretsiz projeyi destekler 🤍",
    reviewButton: "Uygulamayı Değerlendir",
    reviewLater: "Sonra",
    reviewNever: "Bir daha sorma",
    
    // Post-Deed Modal (Dua)
    postDeedGift: "Bu ameli yapabilmen Allah'tan bir hediyedir.",
    postDeedDua: "Allah'ım, benden kabul et.",
    postDeedTitle: "Maşallah!",
    postDeedMessage: "Allah kabul etsin. Yarın yeni bir büyüme fırsatı var – hazır ol!",
    postDeedContinue: "Devam",
    postDeedOptionsTitle: "Ne yapmak istersin?",
    postDeedAddThoughts: "Düşünce ekle",
    postDeedViewMilestones: "Başarıları gör",
    postDeedSkip: "Atla",
    postDeedFeelingsTitle: "Bu amelden sonra nasıl hissediyorsun?",
    feelingMotivated: "Motive & daha fazlasına hazır 💪",
    feelingGrateful: "Başardıklarım için minnettar 🙏",
    feelingSatisfied: "Biraz yorgun ama memnun 😌",
    feelingExcited: "Sonraki amel için heyecanlı 🚀",
    feelingEnough: "Bugün yeterli – yarın görüşürüz!",
    feelingThanks: "Paylaştığın için teşekkürler! 💚",
    postDeedMilestonesTitle: "Başarıların",
    postDeedDone: "Tamam",
    
    // Intention (Post-Deed)
    intentionQuestion: "Bu ameli hangi niyetle yaptın?",
    intentionForAllah: "Bilinçli olarak Allah için yaptım",
    intentionEffort: "Zor olsa da çabaladım",
    intentionHumble: "Sessizce ve beklentisiz yaptım",
    intentionHope: "Allah'ın kabul etmesini umuyorum",
    confirmationPure: "Saf niyet amele ağırlık verir.",
    confirmationEffort: "Küçük bir çaba bile değerlidir.",
    confirmationSeen: "Allah kalbinde olanı görür.",
    reflectionTitle: "TEFEKKÜR",
    
    // Category Focus (Premium)
    categoryFocusTitle: "Odak Noktanız",
    categoryFocusSubtext: "Odaklanmış ameller için bir kategori seçin",
    categoryAll: "Tüm Kategoriler",
    categoryFocusActive: "Aktif",
    changeFocus: "Odağı Değiştir",
    
    // Feedback Modal
    feedback: "Geri Bildirim",
    feedbackTitle: "Geri Bildirim",
    feedbackFeatureTitle: "İyileştirme önerileri memnuniyetle karşılanır.",
    feedbackFeatureButton: "Özellik İsteği Gönder",
    feedbackFeaturePlaceholder: "Fikrini açıkla...",
    feedbackContactTitle: "Bir hata buldun veya yapıcı eleştirin mi var?",
    feedbackContactButton: "Bize yaz",
    feedbackSent: "Geri bildirimin için teşekkürler!",
    feedbackClose: "Kapat",
    
    // Footer links
    privacyPolicy: "Gizlilik",
    support: "Destek",
    privacyUrl: "/privacy.html",
    supportUrl: "/support.html",
  }
};

// Good deeds in all languages - 50 deeds with "today" focus
export const goodDeeds = {
  de: [
    { text: "Lächle heute einer Person mit der Absicht, ihr Gutes zu tun.", source: "Sahih Muslim 1009" },
    { text: "Begrüße heute bewusst jemanden mit Salam.", source: "Sahih Muslim 54" },
    { text: "Sprich heute dreimal Subhanallah mit Bedacht.", source: "Sure 33:41" },
    { text: "Sage heute bewusst Alhamdulillah für etwas Kleines.", source: "Sure 14:7" },
    { text: "Reagiere heute geduldig statt impulsiv.", source: "Sure 3:134" },
    { text: "Unterlasse heute jegliches Lästern.", source: "Sure 49:12" },
    { text: "Tue heute etwas Gutes für deine Eltern.", source: "Sure 17:23" },
    { text: "Lies heute mindestens einen Vers aus dem Qurʾan.", source: "Sure 2:121" },
    { text: "Sprich heute ein Duʿa für eine andere Person.", source: "Sahih Muslim 2733" },
    { text: "Sprich heute bewusst ein freundliches Wort.", source: "Sahih al-Bukhari 6475" },
    { text: "Unterlasse heute Worte, wenn du wütend wirst.", source: "Sahih al-Bukhari 6116" },
    { text: "Überprüfe heute deine Absicht bei einer Handlung.", source: "Sahih al-Bukhari 1" },
    { text: "Gib heute eine kleine Sadaqah.", source: "Sure 2:261" },
    { text: "Bedanke dich heute bei einer Person.", source: "Sahih al-Bukhari 2074" },
    { text: "Behandle heute deinen Nachbarn freundlich.", source: "Sahih al-Bukhari 6014" },
    { text: "Sorge heute für Sauberkeit in deinem Umfeld.", source: "Sahih Muslim 223" },
    { text: "Beherrsche heute bewusst deinen Zorn.", source: "Sahih al-Bukhari 6116" },
    { text: "Vergib heute jemandem innerlich.", source: "Sure 24:22" },
    { text: "Hilf heute jemandem bei einer Kleinigkeit.", source: "Sahih Muslim 1009" },
    { text: "Sprich heute La ilaha illa Allah einmal bewusst.", source: "Sahih Muslim 2691" },
    { text: "Meide heute schlechte Gedanken über andere.", source: "Sure 49:12" },
    { text: "Verrichte heute ein Gebet pünktlich.", source: "Sahih al-Bukhari 527" },
    { text: "Sprich heute ruhig und respektvoll.", source: "Sure 31:19" },
    { text: "Beginne heute eine Arbeit mit guter Absicht.", source: "Sahih al-Bukhari 1" },
    { text: "Nutze heute deine Zeit bewusst.", source: "Sahih al-Bukhari 6412" },
    { text: "Iss heute bewusst und dankbar.", source: "Sahih Muslim 2032" },
    { text: "Ziehe dich heute aus einem Streit zurück.", source: "Sunan Abi Dawud 4800" },
    { text: "Behandle heute ein Tier mit Barmherzigkeit.", source: "Sahih al-Bukhari 3321" },
    { text: "Denke heute gut über Allah.", source: "Sahih Muslim 2675" },
    { text: "Bitte heute Allah um Vergebung.", source: "Sahih Muslim 2702" },
    { text: "Sprich heute bewusst die Wahrheit.", source: "Sahih Muslim 2607" },
    { text: "Meide heute Neid gegenüber anderen.", source: "Sure 113:5" },
    { text: "Sprich heute ein kurzes persönliches Duʿa.", source: "Sahih Muslim 2697" },
    { text: "Reagiere heute sanft statt hart.", source: "Sahih Muslim 2593" },
    { text: "Verbringe heute bewusste Zeit mit deiner Familie.", source: "Sahih al-Bukhari 6039" },
    { text: "Senke heute bewusst deinen Blick.", source: "Sure 24:30" },
    { text: "Bewahre heute gute Hoffnung auf Allah.", source: "Sahih Muslim 2675" },
    { text: "Behandle heute Wissen mit Respekt.", source: "Sure 20:114" },
    { text: "Meide heute Hochmut in deinem Herzen.", source: "Sahih Muslim 91" },
    { text: "Bitte heute Allah um Barakah in deinem Alltag.", source: "Sure 7:96" },
    { text: "Gedenke heute Allah leise.", source: "Sure 7:205" },
    { text: "Vertraue heute Allah in einer Angelegenheit.", source: "Sure 65:3" },
    { text: "Erwarte heute Gutes von anderen.", source: "Sahih al-Bukhari 6018" },
    { text: "Handle heute bescheiden.", source: "Sahih Muslim 2588" },
    { text: "Nimm dir heute einen Moment für Nachdenken.", source: "Sure 59:18" },
    { text: "Handle heute gerecht.", source: "Sure 16:90" },
    { text: "Höre heute jemandem aufmerksam zu.", source: "Sahih Muslim 2564" },
    { text: "Sprich heute freundlich und ruhig.", source: "Sure 20:44" },
    { text: "Erkenne heute Allahs Gaben bewusst an.", source: "Sure 31:12" },
    { text: "Erneuere heute deine gute Absicht im Alltag.", source: "Sahih al-Bukhari 1" },
    // Deeds 51-100
    { text: "Unterstütze heute eine Person, die Hilfe braucht.", source: "Sahih Muslim 1009" },
    { text: "Achte heute bewusst auf die Reinheit deiner Hände.", source: "Sahih al-Bukhari 246" },
    { text: "Erinnere dich heute vor dem Schlafen an Allah.", source: "Sahih Muslim 2715" },
    { text: "Achte heute darauf, dass deine Kleidung sauber ist.", source: "Sahih Muslim 223" },
    { text: "Übe dich heute in Mitgefühl gegenüber anderen.", source: "Sure 2:263" },
    { text: "Gib heute einem Tier etwas zu essen oder zu trinken.", source: "Sahih al-Bukhari 3321" },
    { text: "Spende heute einen kleinen Betrag an Bedürftige.", source: "Sure 2:261" },
    { text: "Übe heute Geduld in einer Situation, in der du warten musst.", source: "Sure 2:153" },
    { text: "Sprich heute freundlich mit jemandem am Telefon.", source: "Sahih al-Bukhari 6014" },
    { text: "Sprich heute Bismillah vor dem Essen und Alhamdulillah danach.", source: "Sahih Muslim 2032" },
    { text: "Vergib heute jemandem, der dich verletzt hat.", source: "Sure 24:22" },
    { text: "Überprüfe heute, ob deine Handlungen halal und gerecht sind.", source: "Sure 16:90" },
    { text: "Höre heute bewusst jemandem zu, ohne zu unterbrechen.", source: "Sahih Muslim 2564" },
    { text: "Kleide dich heute sauber und bescheiden.", source: "Sure 7:26" },
    { text: "Achte heute auf gute Haltung als Zeichen der Ehrerbietung.", source: "Sahih al-Bukhari 6116" },
    { text: "Lies heute einen Qurʾan-Vers und denke über seine Bedeutung nach.", source: "Sure 38:29" },
    { text: "Bete heute für den Erfolg und das Wohl anderer.", source: "Sahih Muslim 2733" },
    { text: "Sage heute ein freundliches Wort zu deinem Nachbarn.", source: "Sahih al-Bukhari 6014" },
    { text: "Halte heute dein Zuhause und deinen Arbeitsplatz sauber.", source: "Sahih Muslim 223" },
    { text: "Entschuldige dich heute bei jemandem, dem du Unrecht getan hast.", source: "Sahih Muslim 2607" },
    { text: "Lobe heute bewusst eine andere Person.", source: "Sahih al-Bukhari 6018" },
    { text: "Sei heute ehrlich in allen kleinen und großen Angelegenheiten.", source: "Sahih Muslim 2607" },
    { text: "Zeige heute besondere Freundlichkeit gegenüber Kindern.", source: "Sahih al-Bukhari 5998" },
    { text: "Sprich heute ein Duʿa für Verstorbene.", source: "Sahih Muslim 961" },
    { text: "Denke heute gut über die Menschen um dich herum.", source: "Sahih Muslim 2675" },
    { text: "Versuche heute eine schlechte Angewohnheit zu reduzieren.", source: "Sahih al-Bukhari 6066" },
    { text: "Vermeide heute Verschwendung bei Lebensmitteln und Ressourcen.", source: "Sure 7:31" },
    { text: "Sprich heute ein stilles Duʿa für dich und andere.", source: "Sahih Muslim 2700" },
    { text: "Denke heute positiv über Allahs Plan.", source: "Sahih Muslim 2675" },
    { text: "Lächle heute bewusst jemandem, den du nicht kennst.", source: "Sahih Muslim 1009" },
    { text: "Übernimm heute Verantwortung für eine Aufgabe, ohne zu klagen.", source: "Sahih al-Bukhari 6116" },
    { text: "Verschenke heute etwas Kleines an eine Person.", source: "Sahih Muslim 1009" },
    { text: "Überdenke heute deine Worte und Taten.", source: "Sahih al-Bukhari 1" },
    { text: "Achte heute beim Wudhu auf sparsamen Wasserverbrauch.", source: "Sahih Muslim 261" },
    { text: "Lies heute ein Buch, das dich näher zu Allah bringt.", source: "Sahih al-Bukhari 5027" },
    { text: "Begrüße heute bewusst jede Person, die du triffst.", source: "Sahih Muslim 54" },
    { text: "Sei heute aufmerksam gegenüber den Bedürfnissen anderer.", source: "Sahih Muslim 2564" },
    { text: "Übe heute Barmherzigkeit in kleinen alltäglichen Situationen.", source: "Sahih Muslim 91" },
    { text: "Biete heute einem Gast ein Getränk an.", source: "Sahih al-Bukhari 6015" },
    { text: "Sprich heute während des Tages ein kurzes Dhikr.", source: "Sahih Muslim 2691" },
    { text: "Starte heute jede Arbeit mit der Absicht, Allah zu gefallen.", source: "Sahih al-Bukhari 1" },
    { text: "Verabschiede dich heute freundlich von Menschen.", source: "Sahih Muslim 54" },
    { text: "Vermeide heute Prahlen und Selbstlob.", source: "Sahih Muslim 2588" },
    { text: "Bitte heute Allah um Segen, bevor du eine Arbeit beginnst.", source: "Sure 7:96" },
    { text: "Sprich heute ein aufbauendes Wort zu Bedürftigen.", source: "Sahih al-Bukhari 6014" },
    { text: "Tue heute bewusst etwas Gutes für eine andere Person.", source: "Sahih Muslim 1009" },
    { text: "Sei heute rücksichtsvoll und freundlich unterwegs.", source: "Sahih al-Bukhari 6018" },
    { text: "Sprich heute ein kurzes Dhikr, wenn du wartest oder gehst.", source: "Sahih Muslim 2691" },
    { text: "Lache heute sanft, ohne andere zu verspotten.", source: "Sahih al-Bukhari 6050" },
    { text: "Denke heute vor dem Schlafen an die guten Dinge des Tages und danke Allah.", source: "Sahih Muslim 2715" },
  ],
  en: [
    { text: "Smile at someone today with the intention of doing good.", source: "Sahih Muslim 1009" },
    { text: "Consciously greet someone with Salam today.", source: "Sahih Muslim 54" },
    { text: "Say Subhanallah three times mindfully today.", source: "Surah 33:41" },
    { text: "Consciously say Alhamdulillah for something small today.", source: "Surah 14:7" },
    { text: "React patiently instead of impulsively today.", source: "Surah 3:134" },
    { text: "Refrain from any gossip today.", source: "Surah 49:12" },
    { text: "Do something good for your parents today.", source: "Surah 17:23" },
    { text: "Read at least one verse from the Quran today.", source: "Surah 2:121" },
    { text: "Make a Dua for another person today.", source: "Sahih Muslim 2733" },
    { text: "Consciously speak a kind word today.", source: "Sahih al-Bukhari 6475" },
    { text: "Hold back words when you feel angry today.", source: "Sahih al-Bukhari 6116" },
    { text: "Check your intention before an action today.", source: "Sahih al-Bukhari 1" },
    { text: "Give a small Sadaqah today.", source: "Surah 2:261" },
    { text: "Thank someone today.", source: "Sahih al-Bukhari 2074" },
    { text: "Treat your neighbor kindly today.", source: "Sahih al-Bukhari 6014" },
    { text: "Keep your surroundings clean today.", source: "Sahih Muslim 223" },
    { text: "Consciously control your anger today.", source: "Sahih al-Bukhari 6116" },
    { text: "Forgive someone in your heart today.", source: "Surah 24:22" },
    { text: "Help someone with something small today.", source: "Sahih Muslim 1009" },
    { text: "Say La ilaha illa Allah consciously once today.", source: "Sahih Muslim 2691" },
    { text: "Avoid negative thoughts about others today.", source: "Surah 49:12" },
    { text: "Perform a prayer on time today.", source: "Sahih al-Bukhari 527" },
    { text: "Speak calmly and respectfully today.", source: "Surah 31:19" },
    { text: "Begin a task with good intention today.", source: "Sahih al-Bukhari 1" },
    { text: "Use your time consciously today.", source: "Sahih al-Bukhari 6412" },
    { text: "Eat mindfully and gratefully today.", source: "Sahih Muslim 2032" },
    { text: "Withdraw from an argument today.", source: "Sunan Abi Dawud 4800" },
    { text: "Treat an animal with mercy today.", source: "Sahih al-Bukhari 3321" },
    { text: "Think well of Allah today.", source: "Sahih Muslim 2675" },
    { text: "Ask Allah for forgiveness today.", source: "Sahih Muslim 2702" },
    { text: "Speak the truth consciously today.", source: "Sahih Muslim 2607" },
    { text: "Avoid envy towards others today.", source: "Surah 113:5" },
    { text: "Make a short personal Dua today.", source: "Sahih Muslim 2697" },
    { text: "React gently instead of harshly today.", source: "Sahih Muslim 2593" },
    { text: "Spend quality time with your family today.", source: "Sahih al-Bukhari 6039" },
    { text: "Lower your gaze consciously today.", source: "Surah 24:30" },
    { text: "Maintain good hope in Allah today.", source: "Sahih Muslim 2675" },
    { text: "Treat knowledge with respect today.", source: "Surah 20:114" },
    { text: "Avoid arrogance in your heart today.", source: "Sahih Muslim 91" },
    { text: "Ask Allah for Barakah in your day today.", source: "Surah 7:96" },
    { text: "Remember Allah quietly today.", source: "Surah 7:205" },
    { text: "Trust Allah in a matter today.", source: "Surah 65:3" },
    { text: "Expect good from others today.", source: "Sahih al-Bukhari 6018" },
    { text: "Act with humility today.", source: "Sahih Muslim 2588" },
    { text: "Take a moment to reflect today.", source: "Surah 59:18" },
    { text: "Act justly today.", source: "Surah 16:90" },
    { text: "Listen attentively to someone today.", source: "Sahih Muslim 2564" },
    { text: "Speak kindly and calmly today.", source: "Surah 20:44" },
    { text: "Consciously acknowledge Allah's blessings today.", source: "Surah 31:12" },
    { text: "Renew your good intention in daily life today.", source: "Sahih al-Bukhari 1" },
    // Deeds 51-100
    { text: "Support someone who needs help today.", source: "Sahih Muslim 1009" },
    { text: "Be mindful of the cleanliness of your hands today.", source: "Sahih al-Bukhari 246" },
    { text: "Remember Allah before sleeping today.", source: "Sahih Muslim 2715" },
    { text: "Make sure your clothes are clean today.", source: "Sahih Muslim 223" },
    { text: "Practice compassion towards others today.", source: "Surah 2:263" },
    { text: "Give an animal something to eat or drink today.", source: "Sahih al-Bukhari 3321" },
    { text: "Donate a small amount to those in need today.", source: "Surah 2:261" },
    { text: "Practice patience in a situation where you have to wait today.", source: "Surah 2:153" },
    { text: "Speak kindly to someone on the phone today.", source: "Sahih al-Bukhari 6014" },
    { text: "Say Bismillah before eating and Alhamdulillah after today.", source: "Sahih Muslim 2032" },
    { text: "Forgive someone who has hurt you today.", source: "Surah 24:22" },
    { text: "Check if your actions are halal and just today.", source: "Surah 16:90" },
    { text: "Listen consciously to someone without interrupting today.", source: "Sahih Muslim 2564" },
    { text: "Dress cleanly and modestly today.", source: "Surah 7:26" },
    { text: "Maintain good posture as a sign of respect today.", source: "Sahih al-Bukhari 6116" },
    { text: "Read a Quran verse and reflect on its meaning today.", source: "Surah 38:29" },
    { text: "Pray for the success and well-being of others today.", source: "Sahih Muslim 2733" },
    { text: "Say a kind word to your neighbor today.", source: "Sahih al-Bukhari 6014" },
    { text: "Keep your home and workplace clean today.", source: "Sahih Muslim 223" },
    { text: "Apologize to someone you have wronged today.", source: "Sahih Muslim 2607" },
    { text: "Consciously praise another person today.", source: "Sahih al-Bukhari 6018" },
    { text: "Be honest in all small and big matters today.", source: "Sahih Muslim 2607" },
    { text: "Show special kindness to children today.", source: "Sahih al-Bukhari 5998" },
    { text: "Make a Dua for the deceased today.", source: "Sahih Muslim 961" },
    { text: "Think well of the people around you today.", source: "Sahih Muslim 2675" },
    { text: "Try to reduce a bad habit today.", source: "Sahih al-Bukhari 6066" },
    { text: "Avoid wasting food and resources today.", source: "Surah 7:31" },
    { text: "Make a silent Dua for yourself and others today.", source: "Sahih Muslim 2700" },
    { text: "Think positively about Allah's plan today.", source: "Sahih Muslim 2675" },
    { text: "Consciously smile at someone you don't know today.", source: "Sahih Muslim 1009" },
    { text: "Take responsibility for a task without complaining today.", source: "Sahih al-Bukhari 6116" },
    { text: "Give something small to someone today.", source: "Sahih Muslim 1009" },
    { text: "Reflect on your words and actions today.", source: "Sahih al-Bukhari 1" },
    { text: "Be mindful of water usage during Wudhu today.", source: "Sahih Muslim 261" },
    { text: "Read a book that brings you closer to Allah today.", source: "Sahih al-Bukhari 5027" },
    { text: "Consciously greet every person you meet today.", source: "Sahih Muslim 54" },
    { text: "Be attentive to the needs of others today.", source: "Sahih Muslim 2564" },
    { text: "Practice mercy in small everyday situations today.", source: "Sahih Muslim 91" },
    { text: "Offer a guest a drink today.", source: "Sahih al-Bukhari 6015" },
    { text: "Say a short Dhikr during the day today.", source: "Sahih Muslim 2691" },
    { text: "Start every task with the intention to please Allah today.", source: "Sahih al-Bukhari 1" },
    { text: "Say goodbye kindly to people today.", source: "Sahih Muslim 54" },
    { text: "Avoid boasting and self-praise today.", source: "Sahih Muslim 2588" },
    { text: "Ask Allah for blessing before starting work today.", source: "Surah 7:96" },
    { text: "Speak an uplifting word to those in need today.", source: "Sahih al-Bukhari 6014" },
    { text: "Consciously do something good for another person today.", source: "Sahih Muslim 1009" },
    { text: "Be considerate and friendly on the road today.", source: "Sahih al-Bukhari 6018" },
    { text: "Say a short Dhikr when waiting or walking today.", source: "Sahih Muslim 2691" },
    { text: "Laugh gently without mocking others today.", source: "Sahih al-Bukhari 6050" },
    { text: "Think of the good things of the day and thank Allah before sleeping today.", source: "Sahih Muslim 2715" },
  ],
  bs: [
    { text: "Nasmiješi se danas nekome s namjerom da mu učiniš dobro.", source: "Sahih Muslim 1009" },
    { text: "Svjesno danas nekoga pozdravi sa Selamom.", source: "Sahih Muslim 54" },
    { text: "Izgovori danas Subhanallah tri puta sa razmišljanjem.", source: "Sura 33:41" },
    { text: "Svjesno danas reci Elhamdulillah za nešto malo.", source: "Sura 14:7" },
    { text: "Reaguj danas strpljivo umjesto impulsivno.", source: "Sura 3:134" },
    { text: "Izbjegavaj danas svako ogovaranje.", source: "Sura 49:12" },
    { text: "Učini danas nešto dobro za svoje roditelje.", source: "Sura 17:23" },
    { text: "Pročitaj danas barem jedan ajet iz Kur'ana.", source: "Sura 2:121" },
    { text: "Uputi danas dovu za drugu osobu.", source: "Sahih Muslim 2733" },
    { text: "Izgovori danas svjesno lijepu riječ.", source: "Sahih al-Bukhari 6475" },
    { text: "Suzdržaj se danas od riječi kada se naljutiš.", source: "Sahih al-Bukhari 6116" },
    { text: "Provjeri danas svoju namjeru prije djela.", source: "Sahih al-Bukhari 1" },
    { text: "Daj danas malu sadaku.", source: "Sura 2:261" },
    { text: "Zahvali se danas nekoj osobi.", source: "Sahih al-Bukhari 2074" },
    { text: "Postupaj danas ljubazno prema komšiji.", source: "Sahih al-Bukhari 6014" },
    { text: "Pobrini se danas za čistoću svoje okoline.", source: "Sahih Muslim 223" },
    { text: "Svjesno danas kontroliši svoju srdžbu.", source: "Sahih al-Bukhari 6116" },
    { text: "Oprosti danas nekome u svom srcu.", source: "Sura 24:22" },
    { text: "Pomozi danas nekome u sitnici.", source: "Sahih Muslim 1009" },
    { text: "Izgovori danas svjesno La ilahe illallah.", source: "Sahih Muslim 2691" },
    { text: "Izbjegavaj danas loše misli o drugima.", source: "Sura 49:12" },
    { text: "Obavi danas namaz na vrijeme.", source: "Sahih al-Bukhari 527" },
    { text: "Govori danas smireno i s poštovanjem.", source: "Sura 31:19" },
    { text: "Započni danas posao s dobrom namjerom.", source: "Sahih al-Bukhari 1" },
    { text: "Iskoristi danas vrijeme svjesno.", source: "Sahih al-Bukhari 6412" },
    { text: "Jedi danas svjesno i sa zahvalnošću.", source: "Sahih Muslim 2032" },
    { text: "Povuci se danas iz svađe.", source: "Sunan Abi Dawud 4800" },
    { text: "Postupaj danas milostivo prema životinji.", source: "Sahih al-Bukhari 3321" },
    { text: "Misli danas dobro o Allahu.", source: "Sahih Muslim 2675" },
    { text: "Zamoli danas Allaha za oprost.", source: "Sahih Muslim 2702" },
    { text: "Govori danas svjesno istinu.", source: "Sahih Muslim 2607" },
    { text: "Izbjegavaj danas zavist prema drugima.", source: "Sura 113:5" },
    { text: "Uputi danas kratku ličnu dovu.", source: "Sahih Muslim 2697" },
    { text: "Reaguj danas blago umjesto oštro.", source: "Sahih Muslim 2593" },
    { text: "Provedi danas kvalitetno vrijeme s porodicom.", source: "Sahih al-Bukhari 6039" },
    { text: "Obori danas svjesno pogled.", source: "Sura 24:30" },
    { text: "Čuvaj danas dobru nadu u Allaha.", source: "Sahih Muslim 2675" },
    { text: "Postupaj danas prema znanju s poštovanjem.", source: "Sura 20:114" },
    { text: "Izbjegavaj danas oholost u srcu.", source: "Sahih Muslim 91" },
    { text: "Zamoli danas Allaha za bereket u danu.", source: "Sura 7:96" },
    { text: "Sjećaj se danas Allaha tiho.", source: "Sura 7:205" },
    { text: "Osloni se danas na Allaha u jednoj stvari.", source: "Sura 65:3" },
    { text: "Očekuj danas dobro od drugih.", source: "Sahih al-Bukhari 6018" },
    { text: "Postupaj danas skromno.", source: "Sahih Muslim 2588" },
    { text: "Uzmi danas trenutak za razmišljanje.", source: "Sura 59:18" },
    { text: "Postupaj danas pravedno.", source: "Sura 16:90" },
    { text: "Slušaj danas nekoga pažljivo.", source: "Sahih Muslim 2564" },
    { text: "Govori danas ljubazno i smireno.", source: "Sura 20:44" },
    { text: "Prepoznaj danas svjesno Allahove blagodati.", source: "Sura 31:12" },
    { text: "Obnovi danas dobru namjeru u svakodnevici.", source: "Sahih al-Bukhari 1" },
    // Deeds 51-100
    { text: "Podrži danas nekoga kome treba pomoć.", source: "Sahih Muslim 1009" },
    { text: "Pazi danas na čistoću svojih ruku.", source: "Sahih al-Bukhari 246" },
    { text: "Sjeti se danas Allaha prije spavanja.", source: "Sahih Muslim 2715" },
    { text: "Pazi danas da ti je odjeća čista.", source: "Sahih Muslim 223" },
    { text: "Vježbaj danas saosjećanje prema drugima.", source: "Sura 2:263" },
    { text: "Daj danas životinji nešto za jelo ili piće.", source: "Sahih al-Bukhari 3321" },
    { text: "Doniraj danas mali iznos potrebitima.", source: "Sura 2:261" },
    { text: "Vježbaj danas strpljenje u situaciji čekanja.", source: "Sura 2:153" },
    { text: "Govori danas ljubazno s nekim na telefonu.", source: "Sahih al-Bukhari 6014" },
    { text: "Reci danas Bismillah prije jela i Elhamdulillah poslije.", source: "Sahih Muslim 2032" },
    { text: "Oprosti danas nekome ko te povrijedio.", source: "Sura 24:22" },
    { text: "Provjeri danas jesu li tvoja djela halal i pravedna.", source: "Sura 16:90" },
    { text: "Slušaj danas nekoga svjesno bez prekidanja.", source: "Sahih Muslim 2564" },
    { text: "Odjeni se danas čisto i skromno.", source: "Sura 7:26" },
    { text: "Održavaj danas dobro držanje kao znak poštovanja.", source: "Sahih al-Bukhari 6116" },
    { text: "Pročitaj danas ajet i razmisli o njegovom značenju.", source: "Sura 38:29" },
    { text: "Moli danas za uspjeh i dobrobit drugih.", source: "Sahih Muslim 2733" },
    { text: "Reci danas lijepu riječ svom komšiji.", source: "Sahih al-Bukhari 6014" },
    { text: "Održavaj danas čistoću doma i radnog mjesta.", source: "Sahih Muslim 223" },
    { text: "Izvini se danas nekome kome si nanio nepravdu.", source: "Sahih Muslim 2607" },
    { text: "Pohvali danas svjesno drugu osobu.", source: "Sahih al-Bukhari 6018" },
    { text: "Budi danas iskren u malim i velikim stvarima.", source: "Sahih Muslim 2607" },
    { text: "Pokaži danas posebnu ljubaznost prema djeci.", source: "Sahih al-Bukhari 5998" },
    { text: "Uputi danas dovu za umrle.", source: "Sahih Muslim 961" },
    { text: "Misli danas dobro o ljudima oko sebe.", source: "Sahih Muslim 2675" },
    { text: "Pokušaj danas smanjiti lošu naviku.", source: "Sahih al-Bukhari 6066" },
    { text: "Izbjegavaj danas rasipanje hrane i resursa.", source: "Sura 7:31" },
    { text: "Uputi danas tihu dovu za sebe i druge.", source: "Sahih Muslim 2700" },
    { text: "Misli danas pozitivno o Allahovom planu.", source: "Sahih Muslim 2675" },
    { text: "Nasmiješi se danas svjesno nekome koga ne poznaješ.", source: "Sahih Muslim 1009" },
    { text: "Preuzmi danas odgovornost za zadatak bez žaljenja.", source: "Sahih al-Bukhari 6116" },
    { text: "Pokloni danas nešto malo nekoj osobi.", source: "Sahih Muslim 1009" },
    { text: "Razmisli danas o svojim riječima i djelima.", source: "Sahih al-Bukhari 1" },
    { text: "Pazi danas na štednju vode pri abdesta.", source: "Sahih Muslim 261" },
    { text: "Pročitaj danas knjigu koja te približava Allahu.", source: "Sahih al-Bukhari 5027" },
    { text: "Pozdravi danas svjesno svaku osobu koju sretneš.", source: "Sahih Muslim 54" },
    { text: "Budi danas pažljiv prema potrebama drugih.", source: "Sahih Muslim 2564" },
    { text: "Vježbaj danas milost u malim svakodnevnim situacijama.", source: "Sahih Muslim 91" },
    { text: "Ponudi danas gostu piće.", source: "Sahih al-Bukhari 6015" },
    { text: "Izgovori danas kratak zikr tokom dana.", source: "Sahih Muslim 2691" },
    { text: "Započni danas svaki posao s namjerom da ugadiš Allahu.", source: "Sahih al-Bukhari 1" },
    { text: "Pozdravi se danas ljubazno s ljudima.", source: "Sahih Muslim 54" },
    { text: "Izbjegavaj danas hvalisanje i samohvalu.", source: "Sahih Muslim 2588" },
    { text: "Zamoli danas Allaha za bereket prije posla.", source: "Sura 7:96" },
    { text: "Reci danas ohrabrujuću riječ potrebitima.", source: "Sahih al-Bukhari 6014" },
    { text: "Učini danas svjesno nešto dobro za drugu osobu.", source: "Sahih Muslim 1009" },
    { text: "Budi danas obziran i ljubazan u prometu.", source: "Sahih al-Bukhari 6018" },
    { text: "Izgovori danas kratak zikr dok čekaš ili hodaš.", source: "Sahih Muslim 2691" },
    { text: "Nasmij se danas blago bez ismijavanja drugih.", source: "Sahih al-Bukhari 6050" },
    { text: "Razmisli danas prije spavanja o dobrim stvarima dana i zahvali Allahu.", source: "Sahih Muslim 2715" },
  ],
  ar: [
    { text: "ابتسم اليوم في وجه شخص بنية فعل الخير.", source: "صحيح مسلم 1009" },
    { text: "ألقِ السلام على شخص بوعي اليوم.", source: "صحيح مسلم 54" },
    { text: "قل سبحان الله ثلاث مرات بتدبر اليوم.", source: "سورة الأحزاب:41" },
    { text: "قل الحمد لله بوعي على شيء صغير اليوم.", source: "سورة إبراهيم:7" },
    { text: "تصرف بصبر بدلاً من الاندفاع اليوم.", source: "سورة آل عمران:134" },
    { text: "امتنع عن الغيبة اليوم.", source: "سورة الحجرات:12" },
    { text: "افعل شيئاً طيباً لوالديك اليوم.", source: "سورة الإسراء:23" },
    { text: "اقرأ آية واحدة على الأقل من القرآن اليوم.", source: "سورة البقرة:121" },
    { text: "ادعُ لشخص آخر اليوم.", source: "صحيح مسلم 2733" },
    { text: "قل كلمة طيبة بوعي اليوم.", source: "صحيح البخاري 6475" },
    { text: "امسك لسانك عند الغضب اليوم.", source: "صحيح البخاري 6116" },
    { text: "راجع نيتك قبل العمل اليوم.", source: "صحيح البخاري 1" },
    { text: "تصدق بصدقة صغيرة اليوم.", source: "سورة البقرة:261" },
    { text: "اشكر شخصاً اليوم.", source: "صحيح البخاري 2074" },
    { text: "عامل جارك بلطف اليوم.", source: "صحيح البخاري 6014" },
    { text: "حافظ على نظافة محيطك اليوم.", source: "صحيح مسلم 223" },
    { text: "اكظم غيظك بوعي اليوم.", source: "صحيح البخاري 6116" },
    { text: "سامح شخصاً في قلبك اليوم.", source: "سورة النور:22" },
    { text: "ساعد شخصاً في أمر بسيط اليوم.", source: "صحيح مسلم 1009" },
    { text: "قل لا إله إلا الله بوعي مرة اليوم.", source: "صحيح مسلم 2691" },
    { text: "تجنب الأفكار السيئة عن الآخرين اليوم.", source: "سورة الحجرات:12" },
    { text: "صلِّ صلاة في وقتها اليوم.", source: "صحيح البخاري 527" },
    { text: "تحدث بهدوء واحترام اليوم.", source: "سورة لقمان:19" },
    { text: "ابدأ عملاً بنية حسنة اليوم.", source: "صحيح البخاري 1" },
    { text: "استخدم وقتك بوعي اليوم.", source: "صحيح البخاري 6412" },
    { text: "كل بوعي وشكر اليوم.", source: "صحيح مسلم 2032" },
    { text: "انسحب من جدال اليوم.", source: "سنن أبي داود 4800" },
    { text: "عامل حيواناً برحمة اليوم.", source: "صحيح البخاري 3321" },
    { text: "أحسن الظن بالله اليوم.", source: "صحيح مسلم 2675" },
    { text: "استغفر الله اليوم.", source: "صحيح مسلم 2702" },
    { text: "قل الصدق بوعي اليوم.", source: "صحيح مسلم 2607" },
    { text: "تجنب الحسد تجاه الآخرين اليوم.", source: "سورة الفلق:5" },
    { text: "ادعُ دعاءً شخصياً قصيراً اليوم.", source: "صحيح مسلم 2697" },
    { text: "تصرف بلطف بدلاً من القسوة اليوم.", source: "صحيح مسلم 2593" },
    { text: "اقضِ وقتاً نوعياً مع عائلتك اليوم.", source: "صحيح البخاري 6039" },
    { text: "غض بصرك بوعي اليوم.", source: "سورة النور:30" },
    { text: "احتفظ برجاء حسن في الله اليوم.", source: "صحيح مسلم 2675" },
    { text: "عامل العلم باحترام اليوم.", source: "سورة طه:114" },
    { text: "تجنب الكبر في قلبك اليوم.", source: "صحيح مسلم 91" },
    { text: "اسأل الله البركة في يومك اليوم.", source: "سورة الأعراف:96" },
    { text: "اذكر الله بهدوء اليوم.", source: "سورة الأعراف:205" },
    { text: "توكل على الله في أمر اليوم.", source: "سورة الطلاق:3" },
    { text: "توقع الخير من الآخرين اليوم.", source: "صحيح البخاري 6018" },
    { text: "تصرف بتواضع اليوم.", source: "صحيح مسلم 2588" },
    { text: "خذ لحظة للتأمل اليوم.", source: "سورة الحشر:18" },
    { text: "تصرف بعدل اليوم.", source: "سورة النحل:90" },
    { text: "استمع لشخص باهتمام اليوم.", source: "صحيح مسلم 2564" },
    { text: "تحدث بلطف وهدوء اليوم.", source: "سورة طه:44" },
    { text: "اعترف بنعم الله بوعي اليوم.", source: "سورة لقمان:12" },
    { text: "جدد نيتك الحسنة في حياتك اليومية اليوم.", source: "صحيح البخاري 1" },
    // Deeds 51-100
    { text: "ادعم اليوم شخصاً يحتاج المساعدة.", source: "صحيح مسلم 1009" },
    { text: "اهتم اليوم بنظافة يديك.", source: "صحيح البخاري 246" },
    { text: "اذكر الله اليوم قبل النوم.", source: "صحيح مسلم 2715" },
    { text: "تأكد اليوم من نظافة ملابسك.", source: "صحيح مسلم 223" },
    { text: "مارس اليوم الرحمة تجاه الآخرين.", source: "سورة البقرة:263" },
    { text: "أعطِ اليوم حيواناً طعاماً أو شراباً.", source: "صحيح البخاري 3321" },
    { text: "تبرع اليوم بمبلغ صغير للمحتاجين.", source: "سورة البقرة:261" },
    { text: "مارس الصبر اليوم في موقف انتظار.", source: "سورة البقرة:153" },
    { text: "تحدث اليوم بلطف مع شخص على الهاتف.", source: "صحيح البخاري 6014" },
    { text: "قل اليوم بسم الله قبل الأكل والحمد لله بعده.", source: "صحيح مسلم 2032" },
    { text: "سامح اليوم شخصاً آذاك.", source: "سورة النور:22" },
    { text: "تحقق اليوم من أن أفعالك حلال وعادلة.", source: "سورة النحل:90" },
    { text: "استمع اليوم لشخص بوعي دون مقاطعة.", source: "صحيح مسلم 2564" },
    { text: "ارتدِ اليوم ملابس نظيفة ومحتشمة.", source: "سورة الأعراف:26" },
    { text: "حافظ اليوم على وضعية جيدة كعلامة احترام.", source: "صحيح البخاري 6116" },
    { text: "اقرأ اليوم آية وتأمل في معناها.", source: "سورة ص:29" },
    { text: "ادعُ اليوم لنجاح ورفاهية الآخرين.", source: "صحيح مسلم 2733" },
    { text: "قل اليوم كلمة طيبة لجارك.", source: "صحيح البخاري 6014" },
    { text: "حافظ اليوم على نظافة منزلك ومكان عملك.", source: "صحيح مسلم 223" },
    { text: "اعتذر اليوم لشخص ظلمته.", source: "صحيح مسلم 2607" },
    { text: "امدح اليوم شخصاً آخر بوعي.", source: "صحيح البخاري 6018" },
    { text: "كن اليوم صادقاً في الأمور الصغيرة والكبيرة.", source: "صحيح مسلم 2607" },
    { text: "أظهر اليوم لطفاً خاصاً تجاه الأطفال.", source: "صحيح البخاري 5998" },
    { text: "ادعُ اليوم للمتوفين.", source: "صحيح مسلم 961" },
    { text: "فكر اليوم جيداً في الناس من حولك.", source: "صحيح مسلم 2675" },
    { text: "حاول اليوم تقليل عادة سيئة.", source: "صحيح البخاري 6066" },
    { text: "تجنب اليوم إهدار الطعام والموارد.", source: "سورة الأعراف:31" },
    { text: "ادعُ اليوم دعاءً صامتاً لنفسك وللآخرين.", source: "صحيح مسلم 2700" },
    { text: "فكر اليوم إيجابياً في خطة الله.", source: "صحيح مسلم 2675" },
    { text: "ابتسم اليوم بوعي لشخص لا تعرفه.", source: "صحيح مسلم 1009" },
    { text: "تحمل اليوم مسؤولية مهمة دون شكوى.", source: "صحيح البخاري 6116" },
    { text: "أعطِ اليوم شيئاً صغيراً لشخص ما.", source: "صحيح مسلم 1009" },
    { text: "تأمل اليوم في كلماتك وأفعالك.", source: "صحيح البخاري 1" },
    { text: "انتبه اليوم لتوفير الماء عند الوضوء.", source: "صحيح مسلم 261" },
    { text: "اقرأ اليوم كتاباً يقربك من الله.", source: "صحيح البخاري 5027" },
    { text: "حيِّ اليوم بوعي كل شخص تقابله.", source: "صحيح مسلم 54" },
    { text: "كن اليوم منتبهاً لاحتياجات الآخرين.", source: "صحيح مسلم 2564" },
    { text: "مارس اليوم الرحمة في المواقف اليومية الصغيرة.", source: "صحيح مسلم 91" },
    { text: "قدم اليوم لضيف مشروباً.", source: "صحيح البخاري 6015" },
    { text: "اذكر اليوم ذكراً قصيراً خلال النهار.", source: "صحيح مسلم 2691" },
    { text: "ابدأ اليوم كل عمل بنية إرضاء الله.", source: "صحيح البخاري 1" },
    { text: "ودع اليوم الناس بلطف.", source: "صحيح مسلم 54" },
    { text: "تجنب اليوم التفاخر والثناء على النفس.", source: "صحيح مسلم 2588" },
    { text: "اسأل اليوم الله البركة قبل بدء العمل.", source: "سورة الأعراف:96" },
    { text: "قل اليوم كلمة مشجعة للمحتاجين.", source: "صحيح البخاري 6014" },
    { text: "افعل اليوم بوعي شيئاً جيداً لشخص آخر.", source: "صحيح مسلم 1009" },
    { text: "كن اليوم مراعياً ولطيفاً في الطريق.", source: "صحيح البخاري 6018" },
    { text: "اذكر اليوم ذكراً قصيراً عند الانتظار أو المشي.", source: "صحيح مسلم 2691" },
    { text: "اضحك اليوم بلطف دون الاستهزاء بالآخرين.", source: "صحيح البخاري 6050" },
    { text: "فكر اليوم في الأشياء الجيدة واشكر الله قبل النوم.", source: "صحيح مسلم 2715" },
  ],
  id: [
    { text: "Tersenyumlah kepada seseorang hari ini dengan niat berbuat baik.", source: "Sahih Muslim 1009" },
    { text: "Ucapkan salam dengan sadar kepada seseorang hari ini.", source: "Sahih Muslim 54" },
    { text: "Ucapkan Subhanallah tiga kali dengan penuh kesadaran hari ini.", source: "Surah 33:41" },
    { text: "Ucapkan Alhamdulillah dengan sadar untuk sesuatu yang kecil hari ini.", source: "Surah 14:7" },
    { text: "Bersikaplah sabar daripada impulsif hari ini.", source: "Surah 3:134" },
    { text: "Hindari segala bentuk ghibah hari ini.", source: "Surah 49:12" },
    { text: "Lakukan sesuatu yang baik untuk orang tuamu hari ini.", source: "Surah 17:23" },
    { text: "Baca setidaknya satu ayat Al-Quran hari ini.", source: "Surah 2:121" },
    { text: "Doakan orang lain hari ini.", source: "Sahih Muslim 2733" },
    { text: "Ucapkan kata-kata baik dengan sadar hari ini.", source: "Sahih al-Bukhari 6475" },
    { text: "Tahan kata-kata saat marah hari ini.", source: "Sahih al-Bukhari 6116" },
    { text: "Periksa niatmu sebelum bertindak hari ini.", source: "Sahih al-Bukhari 1" },
    { text: "Berikan sedekah kecil hari ini.", source: "Surah 2:261" },
    { text: "Ucapkan terima kasih kepada seseorang hari ini.", source: "Sahih al-Bukhari 2074" },
    { text: "Perlakukan tetanggamu dengan baik hari ini.", source: "Sahih al-Bukhari 6014" },
    { text: "Jaga kebersihan lingkunganmu hari ini.", source: "Sahih Muslim 223" },
    { text: "Kendalikan amarahmu dengan sadar hari ini.", source: "Sahih al-Bukhari 6116" },
    { text: "Maafkan seseorang dalam hatimu hari ini.", source: "Surah 24:22" },
    { text: "Bantu seseorang dalam hal kecil hari ini.", source: "Sahih Muslim 1009" },
    { text: "Ucapkan La ilaha illa Allah dengan sadar sekali hari ini.", source: "Sahih Muslim 2691" },
    { text: "Hindari pikiran buruk tentang orang lain hari ini.", source: "Surah 49:12" },
    { text: "Tunaikan shalat tepat waktu hari ini.", source: "Sahih al-Bukhari 527" },
    { text: "Bicaralah dengan tenang dan hormat hari ini.", source: "Surah 31:19" },
    { text: "Mulai pekerjaan dengan niat baik hari ini.", source: "Sahih al-Bukhari 1" },
    { text: "Gunakan waktumu dengan sadar hari ini.", source: "Sahih al-Bukhari 6412" },
    { text: "Makan dengan penuh kesadaran dan syukur hari ini.", source: "Sahih Muslim 2032" },
    { text: "Mundurlah dari pertengkaran hari ini.", source: "Sunan Abi Dawud 4800" },
    { text: "Perlakukan hewan dengan kasih sayang hari ini.", source: "Sahih al-Bukhari 3321" },
    { text: "Berprasangka baik kepada Allah hari ini.", source: "Sahih Muslim 2675" },
    { text: "Minta ampun kepada Allah hari ini.", source: "Sahih Muslim 2702" },
    { text: "Katakan kebenaran dengan sadar hari ini.", source: "Sahih Muslim 2607" },
    { text: "Hindari iri hati terhadap orang lain hari ini.", source: "Surah 113:5" },
    { text: "Panjatkan doa pribadi singkat hari ini.", source: "Sahih Muslim 2697" },
    { text: "Bersikap lembut daripada keras hari ini.", source: "Sahih Muslim 2593" },
    { text: "Habiskan waktu berkualitas dengan keluarga hari ini.", source: "Sahih al-Bukhari 6039" },
    { text: "Tundukkan pandanganmu dengan sadar hari ini.", source: "Surah 24:30" },
    { text: "Jaga harapan baik kepada Allah hari ini.", source: "Sahih Muslim 2675" },
    { text: "Perlakukan ilmu dengan hormat hari ini.", source: "Surah 20:114" },
    { text: "Hindari kesombongan dalam hati hari ini.", source: "Sahih Muslim 91" },
    { text: "Minta berkah Allah dalam harimu hari ini.", source: "Surah 7:96" },
    { text: "Ingat Allah dengan tenang hari ini.", source: "Surah 7:205" },
    { text: "Bertawakallah kepada Allah dalam suatu urusan hari ini.", source: "Surah 65:3" },
    { text: "Harapkan kebaikan dari orang lain hari ini.", source: "Sahih al-Bukhari 6018" },
    { text: "Bertindaklah dengan rendah hati hari ini.", source: "Sahih Muslim 2588" },
    { text: "Ambil waktu sejenak untuk merenung hari ini.", source: "Surah 59:18" },
    { text: "Bertindaklah adil hari ini.", source: "Surah 16:90" },
    { text: "Dengarkan seseorang dengan penuh perhatian hari ini.", source: "Sahih Muslim 2564" },
    { text: "Bicaralah dengan ramah dan tenang hari ini.", source: "Surah 20:44" },
    { text: "Sadari nikmat Allah dengan sadar hari ini.", source: "Surah 31:12" },
    { text: "Perbarui niat baikmu dalam kehidupan sehari-hari hari ini.", source: "Sahih al-Bukhari 1" },
    // Deeds 51-100
    { text: "Dukung seseorang yang membutuhkan bantuan hari ini.", source: "Sahih Muslim 1009" },
    { text: "Perhatikan kebersihan tanganmu hari ini.", source: "Sahih al-Bukhari 246" },
    { text: "Ingat Allah sebelum tidur hari ini.", source: "Sahih Muslim 2715" },
    { text: "Pastikan pakaianmu bersih hari ini.", source: "Sahih Muslim 223" },
    { text: "Latih kasih sayang terhadap orang lain hari ini.", source: "Surah 2:263" },
    { text: "Beri hewan makanan atau minuman hari ini.", source: "Sahih al-Bukhari 3321" },
    { text: "Donasikan sejumlah kecil kepada yang membutuhkan hari ini.", source: "Surah 2:261" },
    { text: "Latih kesabaran dalam situasi menunggu hari ini.", source: "Surah 2:153" },
    { text: "Bicaralah dengan ramah kepada seseorang di telepon hari ini.", source: "Sahih al-Bukhari 6014" },
    { text: "Ucapkan Bismillah sebelum makan dan Alhamdulillah sesudahnya hari ini.", source: "Sahih Muslim 2032" },
    { text: "Maafkan seseorang yang telah menyakitimu hari ini.", source: "Surah 24:22" },
    { text: "Periksa apakah tindakanmu halal dan adil hari ini.", source: "Surah 16:90" },
    { text: "Dengarkan seseorang dengan sadar tanpa menyela hari ini.", source: "Sahih Muslim 2564" },
    { text: "Berpakaianlah bersih dan sopan hari ini.", source: "Surah 7:26" },
    { text: "Jaga postur baik sebagai tanda hormat hari ini.", source: "Sahih al-Bukhari 6116" },
    { text: "Baca ayat Al-Quran dan renungkan maknanya hari ini.", source: "Surah 38:29" },
    { text: "Doakan kesuksesan dan kesejahteraan orang lain hari ini.", source: "Sahih Muslim 2733" },
    { text: "Ucapkan kata baik kepada tetanggamu hari ini.", source: "Sahih al-Bukhari 6014" },
    { text: "Jaga kebersihan rumah dan tempat kerjamu hari ini.", source: "Sahih Muslim 223" },
    { text: "Minta maaf kepada seseorang yang telah kamu salahi hari ini.", source: "Sahih Muslim 2607" },
    { text: "Pujilah orang lain dengan sadar hari ini.", source: "Sahih al-Bukhari 6018" },
    { text: "Jujurlah dalam hal kecil dan besar hari ini.", source: "Sahih Muslim 2607" },
    { text: "Tunjukkan kebaikan khusus kepada anak-anak hari ini.", source: "Sahih al-Bukhari 5998" },
    { text: "Doakan orang yang telah meninggal hari ini.", source: "Sahih Muslim 961" },
    { text: "Berprasangka baik terhadap orang di sekitarmu hari ini.", source: "Sahih Muslim 2675" },
    { text: "Coba kurangi kebiasaan buruk hari ini.", source: "Sahih al-Bukhari 6066" },
    { text: "Hindari pemborosan makanan dan sumber daya hari ini.", source: "Surah 7:31" },
    { text: "Panjatkan doa dalam hati untuk dirimu dan orang lain hari ini.", source: "Sahih Muslim 2700" },
    { text: "Berpikir positif tentang rencana Allah hari ini.", source: "Sahih Muslim 2675" },
    { text: "Tersenyum dengan sadar kepada orang yang tidak kamu kenal hari ini.", source: "Sahih Muslim 1009" },
    { text: "Ambil tanggung jawab atas tugas tanpa mengeluh hari ini.", source: "Sahih al-Bukhari 6116" },
    { text: "Berikan sesuatu yang kecil kepada seseorang hari ini.", source: "Sahih Muslim 1009" },
    { text: "Renungkan kata-kata dan tindakanmu hari ini.", source: "Sahih al-Bukhari 1" },
    { text: "Perhatikan hemat air saat wudhu hari ini.", source: "Sahih Muslim 261" },
    { text: "Baca buku yang mendekatkanmu kepada Allah hari ini.", source: "Sahih al-Bukhari 5027" },
    { text: "Sapa dengan sadar setiap orang yang kamu temui hari ini.", source: "Sahih Muslim 54" },
    { text: "Perhatikan kebutuhan orang lain hari ini.", source: "Sahih Muslim 2564" },
    { text: "Latih kasih sayang dalam situasi sehari-hari kecil hari ini.", source: "Sahih Muslim 91" },
    { text: "Tawarkan minuman kepada tamu hari ini.", source: "Sahih al-Bukhari 6015" },
    { text: "Ucapkan dzikir singkat sepanjang hari ini.", source: "Sahih Muslim 2691" },
    { text: "Mulai setiap tugas dengan niat menyenangkan Allah hari ini.", source: "Sahih al-Bukhari 1" },
    { text: "Ucapkan selamat tinggal dengan ramah kepada orang hari ini.", source: "Sahih Muslim 54" },
    { text: "Hindari menyombongkan diri dan memuji diri sendiri hari ini.", source: "Sahih Muslim 2588" },
    { text: "Minta berkah Allah sebelum memulai pekerjaan hari ini.", source: "Surah 7:96" },
    { text: "Ucapkan kata-kata yang membangun kepada yang membutuhkan hari ini.", source: "Sahih al-Bukhari 6014" },
    { text: "Lakukan dengan sadar sesuatu yang baik untuk orang lain hari ini.", source: "Sahih Muslim 1009" },
    { text: "Bersikap sopan dan ramah di jalan hari ini.", source: "Sahih al-Bukhari 6018" },
    { text: "Ucapkan dzikir singkat saat menunggu atau berjalan hari ini.", source: "Sahih Muslim 2691" },
    { text: "Tertawa lembut tanpa mengejek orang lain hari ini.", source: "Sahih al-Bukhari 6050" },
    { text: "Pikirkan hal-hal baik hari ini dan syukuri Allah sebelum tidur.", source: "Sahih Muslim 2715" },
  ],
  tr: [
    { text: "Bugün birine iyilik niyetiyle gülümse.", source: "Sahih Muslim 1009" },
    { text: "Bugün bilinçli bir şekilde birine selam ver.", source: "Sahih Muslim 54" },
    { text: "Bugün üç kez bilinçli olarak Sübhanallah de.", source: "Sure 33:41" },
    { text: "Bugün küçük bir şey için bilinçli olarak Elhamdülillah de.", source: "Sure 14:7" },
    { text: "Bugün dürtüsel yerine sabırlı tepki ver.", source: "Sure 3:134" },
    { text: "Bugün her türlü dedikodudan kaçın.", source: "Sure 49:12" },
    { text: "Bugün anne baban için iyi bir şey yap.", source: "Sure 17:23" },
    { text: "Bugün Kur'an'dan en az bir ayet oku.", source: "Sure 2:121" },
    { text: "Bugün başka biri için dua et.", source: "Sahih Muslim 2733" },
    { text: "Bugün bilinçli olarak güzel bir söz söyle.", source: "Sahih al-Bukhari 6475" },
    { text: "Bugün kızgınken söz söylemekten kaçın.", source: "Sahih al-Bukhari 6116" },
    { text: "Bugün bir eylemden önce niyetini kontrol et.", source: "Sahih al-Bukhari 1" },
    { text: "Bugün küçük bir sadaka ver.", source: "Sure 2:261" },
    { text: "Bugün birine teşekkür et.", source: "Sahih al-Bukhari 2074" },
    { text: "Bugün komşuna nazik davran.", source: "Sahih al-Bukhari 6014" },
    { text: "Bugün çevreni temiz tut.", source: "Sahih Muslim 223" },
    { text: "Bugün bilinçli olarak öfkeni kontrol et.", source: "Sahih al-Bukhari 6116" },
    { text: "Bugün kalbinde birini affet.", source: "Sure 24:22" },
    { text: "Bugün birine küçük bir konuda yardım et.", source: "Sahih Muslim 1009" },
    { text: "Bugün bilinçli olarak bir kez La ilahe illallah de.", source: "Sahih Muslim 2691" },
    { text: "Bugün başkaları hakkında kötü düşüncelerden kaçın.", source: "Sure 49:12" },
    { text: "Bugün bir namazı vaktinde kıl.", source: "Sahih al-Bukhari 527" },
    { text: "Bugün sakin ve saygılı konuş.", source: "Sure 31:19" },
    { text: "Bugün bir işe iyi niyetle başla.", source: "Sahih al-Bukhari 1" },
    { text: "Bugün zamanını bilinçli kullan.", source: "Sahih al-Bukhari 6412" },
    { text: "Bugün bilinçli ve şükürle ye.", source: "Sahih Muslim 2032" },
    { text: "Bugün bir tartışmadan çekil.", source: "Sunan Abi Dawud 4800" },
    { text: "Bugün bir hayvana merhametle davran.", source: "Sahih al-Bukhari 3321" },
    { text: "Bugün Allah hakkında iyi düşün.", source: "Sahih Muslim 2675" },
    { text: "Bugün Allah'tan af dile.", source: "Sahih Muslim 2702" },
    { text: "Bugün bilinçli olarak doğruyu söyle.", source: "Sahih Muslim 2607" },
    { text: "Bugün başkalarına karşı kıskançlıktan kaçın.", source: "Sure 113:5" },
    { text: "Bugün kısa kişisel bir dua et.", source: "Sahih Muslim 2697" },
    { text: "Bugün sert yerine yumuşak tepki ver.", source: "Sahih Muslim 2593" },
    { text: "Bugün ailenle kaliteli zaman geçir.", source: "Sahih al-Bukhari 6039" },
    { text: "Bugün bilinçli olarak gözlerini indir.", source: "Sure 24:30" },
    { text: "Bugün Allah'a karşı güzel umut taşı.", source: "Sahih Muslim 2675" },
    { text: "Bugün ilme saygıyla davran.", source: "Sure 20:114" },
    { text: "Bugün kalbinde kibirden kaçın.", source: "Sahih Muslim 91" },
    { text: "Bugün Allah'tan günün bereketini iste.", source: "Sure 7:96" },
    { text: "Bugün Allah'ı sessizce an.", source: "Sure 7:205" },
    { text: "Bugün bir konuda Allah'a tevekkül et.", source: "Sure 65:3" },
    { text: "Bugün başkalarından iyilik bekle.", source: "Sahih al-Bukhari 6018" },
    { text: "Bugün alçakgönüllü davran.", source: "Sahih Muslim 2588" },
    { text: "Bugün düşünmek için bir an ayır.", source: "Sure 59:18" },
    { text: "Bugün adil davran.", source: "Sure 16:90" },
    { text: "Bugün birini dikkatle dinle.", source: "Sahih Muslim 2564" },
    { text: "Bugün nazik ve sakin konuş.", source: "Sure 20:44" },
    { text: "Bugün Allah'ın nimetlerini bilinçli olarak fark et.", source: "Sure 31:12" },
    { text: "Bugün günlük hayatında iyi niyetini yenile.", source: "Sahih al-Bukhari 1" },
    // Deeds 51-100
    { text: "Bugün yardıma ihtiyacı olan birine destek ol.", source: "Sahih Muslim 1009" },
    { text: "Bugün ellerinin temizliğine dikkat et.", source: "Sahih al-Bukhari 246" },
    { text: "Bugün uyumadan önce Allah'ı an.", source: "Sahih Muslim 2715" },
    { text: "Bugün kıyafetlerinin temiz olduğundan emin ol.", source: "Sahih Muslim 223" },
    { text: "Bugün başkalarına karşı şefkat göster.", source: "Sure 2:263" },
    { text: "Bugün bir hayvana yiyecek veya içecek ver.", source: "Sahih al-Bukhari 3321" },
    { text: "Bugün ihtiyaç sahiplerine küçük bir miktar bağışla.", source: "Sure 2:261" },
    { text: "Bugün beklemen gereken bir durumda sabır göster.", source: "Sure 2:153" },
    { text: "Bugün telefonda biriyle nazikçe konuş.", source: "Sahih al-Bukhari 6014" },
    { text: "Bugün yemekten önce Bismillah ve sonra Elhamdülillah de.", source: "Sahih Muslim 2032" },
    { text: "Bugün seni inciten birini affet.", source: "Sure 24:22" },
    { text: "Bugün eylemlerinin helal ve adil olup olmadığını kontrol et.", source: "Sure 16:90" },
    { text: "Bugün birini sözünü kesmeden bilinçli dinle.", source: "Sahih Muslim 2564" },
    { text: "Bugün temiz ve mütevazı giyin.", source: "Sure 7:26" },
    { text: "Bugün saygı göstergesi olarak iyi bir duruş sergile.", source: "Sahih al-Bukhari 6116" },
    { text: "Bugün bir ayet oku ve anlamı üzerinde düşün.", source: "Sure 38:29" },
    { text: "Bugün başkalarının başarısı ve iyiliği için dua et.", source: "Sahih Muslim 2733" },
    { text: "Bugün komşuna güzel bir söz söyle.", source: "Sahih al-Bukhari 6014" },
    { text: "Bugün evini ve işyerini temiz tut.", source: "Sahih Muslim 223" },
    { text: "Bugün haksızlık ettiğin birinden özür dile.", source: "Sahih Muslim 2607" },
    { text: "Bugün bilinçli olarak başka birini öv.", source: "Sahih al-Bukhari 6018" },
    { text: "Bugün küçük ve büyük her konuda dürüst ol.", source: "Sahih Muslim 2607" },
    { text: "Bugün çocuklara özel ilgi göster.", source: "Sahih al-Bukhari 5998" },
    { text: "Bugün vefat edenler için dua et.", source: "Sahih Muslim 961" },
    { text: "Bugün çevrende olan insanlar hakkında iyi düşün.", source: "Sahih Muslim 2675" },
    { text: "Bugün kötü bir alışkanlığı azaltmaya çalış.", source: "Sahih al-Bukhari 6066" },
    { text: "Bugün yiyecek ve kaynak israfından kaçın.", source: "Sure 7:31" },
    { text: "Bugün kendin ve başkaları için sessiz bir dua et.", source: "Sahih Muslim 2700" },
    { text: "Bugün Allah'ın planı hakkında olumlu düşün.", source: "Sahih Muslim 2675" },
    { text: "Bugün tanımadığın birine bilinçli gülümse.", source: "Sahih Muslim 1009" },
    { text: "Bugün şikayet etmeden bir görevin sorumluluğunu al.", source: "Sahih al-Bukhari 6116" },
    { text: "Bugün birine küçük bir şey hediye et.", source: "Sahih Muslim 1009" },
    { text: "Bugün sözlerin ve eylemlerini gözden geçir.", source: "Sahih al-Bukhari 1" },
    { text: "Bugün abdest alırken su tasarrufuna dikkat et.", source: "Sahih Muslim 261" },
    { text: "Bugün seni Allah'a yakınlaştıran bir kitap oku.", source: "Sahih al-Bukhari 5027" },
    { text: "Bugün karşılaştığın herkesi bilinçli selamla.", source: "Sahih Muslim 54" },
    { text: "Bugün başkalarının ihtiyaçlarına duyarlı ol.", source: "Sahih Muslim 2564" },
    { text: "Bugün küçük günlük durumlarda merhamet göster.", source: "Sahih Muslim 91" },
    { text: "Bugün bir misafire içecek ikram et.", source: "Sahih al-Bukhari 6015" },
    { text: "Bugün gün boyunca kısa bir zikir yap.", source: "Sahih Muslim 2691" },
    { text: "Bugün her işe Allah'ı memnun etme niyetiyle başla.", source: "Sahih al-Bukhari 1" },
    { text: "Bugün insanlara nazikçe veda et.", source: "Sahih Muslim 54" },
    { text: "Bugün övünmekten ve kendini övmekten kaçın.", source: "Sahih Muslim 2588" },
    { text: "Bugün işe başlamadan önce Allah'tan bereket iste.", source: "Sure 7:96" },
    { text: "Bugün ihtiyaç sahiplerine cesaret verici bir söz söyle.", source: "Sahih al-Bukhari 6014" },
    { text: "Bugün bilinçli olarak başka biri için iyi bir şey yap.", source: "Sahih Muslim 1009" },
    { text: "Bugün yolda düşünceli ve nazik ol.", source: "Sahih al-Bukhari 6018" },
    { text: "Bugün beklerken veya yürürken kısa bir zikir yap.", source: "Sahih Muslim 2691" },
    { text: "Bugün başkalarıyla alay etmeden yumuşak gül.", source: "Sahih al-Bukhari 6050" },
    { text: "Bugün uyumadan önce günün güzel şeylerini düşün ve Allah'a şükret.", source: "Sahih Muslim 2715" },
  ]
};

// Ramadan deeds in all languages
export const ramadanDeeds = {
  de: [
    { day: 1, text: "Lies heute Surah Al-Fatiha bewusst und reflektiere über ihre Bedeutung.", source: "Sure 1:1-7", tafsir: "Al-Fatiha ist die Essenz des gesamten Qurans – ein Gespräch zwischen dem Diener und Allah, in dem wir um Rechtleitung bitten." },
    { day: 2, text: "Lies heute Surah Al-Baqarah (Verse 183-186) – die Verse über das Fasten im Ramadan.", source: "Sure 2:183-186", tafsir: "In diesen Versen schreibt Allah das Fasten vor und erklärt seinen Zweck: damit ihr Taqwa (Gottesbewusstsein) erlangt." },
    { day: 3, text: "Höre heute Quran-Rezitation für mindestens 10 Minuten.", source: "Sure 7:204", tafsir: "Allah befiehlt, dem Quran aufmerksam zuzuhören und zu schweigen, damit man Barmherzigkeit empfängt." },
    { day: 4, text: "Lies heute Ayat al-Kursi und denke über Allahs Macht nach.", source: "Sure 2:255", tafsir: "Der mächtigste Vers des Qurans beschreibt Allahs absolute Souveränität – Sein Thron umfasst Himmel und Erde." },
    { day: 5, text: "Lies heute Surah Al-Ikhlas dreimal und reflektiere.", source: "Sure 112:1-4", tafsir: "Diese kurze Surah entspricht einem Drittel des Qurans – sie fasst den reinen Monotheismus (Tawhid) zusammen." },
    { day: 6, text: "Lies heute die letzten 10 Verse von Surah Al-Baqarah.", source: "Sure 2:284-286", tafsir: "Allah bürdet keiner Seele mehr auf, als sie tragen kann – diese Verse sind ein Schutz für die Nacht." },
    { day: 7, text: "Lies heute Surah Yasin und bitte Allah um Verständnis.", source: "Sure 36:1-12", tafsir: "Yasin wird das Herz des Qurans genannt – sie handelt von der Auferstehung und den Zeichen Allahs in der Schöpfung." },
    { day: 8, text: "Lies heute Surah Ar-Rahman und zähle Allahs Gaben.", source: "Sure 55:1-16", tafsir: "Allah zählt Seine unzähligen Gaben auf und fragt wiederholt: Welche der Wohltaten eures Herrn wollt ihr leugnen?" },
    { day: 9, text: "Lies heute Surah Al-Mulk vor dem Schlafen.", source: "Sure 67:1-10", tafsir: "Der Prophet ﷺ empfahl diese Surah vor dem Schlafen – sie schützt vor der Strafe des Grabes." },
    { day: 10, text: "Lies heute Surah Al-Kahf und reflektiere über die Geschichten.", source: "Sure 18:1-10", tafsir: "Die Geschichte der Höhlengefährten lehrt, dass Allah die schützt, die um ihres Glaubens willen alles aufgeben." },
    { day: 11, text: "Lies heute einen Juz (Teil) des Qurans.", source: "Sure 2:185", tafsir: "Der Ramadan ist der Monat, in dem der Quran herabgesandt wurde – als Rechtleitung und klare Beweise für die Menschen." },
    { day: 12, text: "Lies heute Surah Maryam und denke über Geduld nach.", source: "Sure 19:1-15", tafsir: "Die Geschichte von Zakariya zeigt: Auch wenn eine Bitte unmöglich scheint, antwortet Allah auf die aufrichtige Dua." },
    { day: 13, text: "Lies heute die Geschichte von Prophet Yusuf (Verse 1-20).", source: "Sure 12:1-20", tafsir: "Die schönste aller Geschichten lehrt, dass hinter jeder Prüfung Allahs weiser Plan verborgen ist." },
    { day: 14, text: "Lies heute Surah Al-Waqiah für Rizq und Segen.", source: "Sure 56:1-20", tafsir: "Der Prophet ﷺ sagte, wer Al-Waqiah jede Nacht liest, wird niemals Armut erleiden." },
    { day: 15, text: "Lies heute Surah Ad-Dukhan und bitte um Schutz.", source: "Sure 44:1-16", tafsir: "Diese Surah wurde in einer gesegneten Nacht offenbart und warnt vor den Folgen der Ablehnung der Wahrheit." },
    { day: 16, text: "Lies heute die Verse über Geduld in Surah Al-Baqarah.", source: "Sure 2:153-157", tafsir: "Allah ist mit den Geduldigen – und auf jene, die in Prüfungen standhaft bleiben, kommen Segen und Barmherzigkeit." },
    { day: 17, text: "Lies heute Surah Al-Anfal und denke über Tawakkul nach.", source: "Sure 8:1-10", tafsir: "Wahres Gottvertrauen (Tawakkul) bedeutet, sich voll auf Allah zu verlassen – und Er genügt als Beschützer." },
    { day: 18, text: "Lies heute Surah At-Tawbah (Verse 1-20).", source: "Sure 9:1-20", tafsir: "Tawbah bedeutet Umkehr – Allah liebt jene, die aufrichtig bereuen und sich Ihm wieder zuwenden." },
    { day: 19, text: "Lies heute Surah Hud und die Geschichten der Propheten.", source: "Sure 11:1-20", tafsir: "Jeder Prophet stand vor scheinbar aussichtslosen Situationen – doch Allahs Hilfe kam stets zur rechten Zeit." },
    { day: 20, text: "Lies heute Surah Ar-Ra'd und denke über Allahs Zeichen nach.", source: "Sure 13:1-15", tafsir: "Selbst der Donner preist Allah – jedes Element der Schöpfung ist ein Zeichen für die, die nachdenken." },
    { day: 21, text: "Lies heute Surah Al-Qadr und bitte um Laylatul Qadr.", source: "Sure 97:1-5", tafsir: "Die Nacht der Bestimmung ist besser als tausend Monate – in ihr steigen die Engel mit Allahs Erlaubnis herab." },
    { day: 22, text: "Lies heute so viel Quran wie möglich - die Nacht könnte Laylatul Qadr sein.", source: "Sure 97:3", tafsir: "Suche diese Nacht in den letzten zehn Nächten – eine einzige Nacht der Ibadah wiegt mehr als 83 Jahre." },
    { day: 23, text: "Lies heute Surah Al-Fajr und denke über den Tag des Gerichts nach.", source: "Sure 89:1-14", tafsir: "Allah schwört bei der Morgendämmerung – eine Warnung vor dem Anhaften an weltlichen Besitz statt an Ihn." },
    { day: 24, text: "Lies heute Surah Ash-Shams und reflektiere über die Seele.", source: "Sure 91:1-10", tafsir: "Erfolg hat, wer seine Seele reinigt – und verloren ist, wer sie mit Sünde verdirbt." },
    { day: 25, text: "Lies heute Surah Al-Lail und Al-Duha.", source: "Sure 92:1-21, 93:1-11", tafsir: "Wer gibt und gottesfürchtig ist, dem erleichtert Allah den Weg – und nach jeder Schwere kommt Erleichterung." },
    { day: 26, text: "Lies heute Surah At-Tin und Al-Alaq.", source: "Sure 95:1-8, 96:1-5", tafsir: "Der Mensch wurde in bester Form erschaffen – und das erste Wort der Offenbarung war: Lies!" },
    { day: 27, text: "Lies heute intensiv Quran - dies könnte Laylatul Qadr sein!", source: "Sure 97:1-5", tafsir: "Der Prophet ﷺ suchte Laylatul Qadr besonders in den ungeraden Nächten – die 27. Nacht gilt als wahrscheinlichste." },
    { day: 28, text: "Lies heute Surah Al-Bayyinah und Al-Zilzal.", source: "Sure 98:1-8, 99:1-8", tafsir: "Jedes Atom an Gutem und jedes Atom an Bösem wird am Tag des Gerichts sichtbar – nichts bleibt verborgen." },
    { day: 29, text: "Lies heute Surah Al-Asr und reflektiere über die Zeit.", source: "Sure 103:1-3", tafsir: "Die kürzeste Warnung des Qurans: Der Mensch ist im Verlust – außer jene, die glauben und Geduld üben." },
    { day: 30, text: "Beende Ramadan mit dem Lesen von Surah An-Nas, Al-Falaq und Al-Ikhlas.", source: "Sure 112-114", tafsir: "Die drei Schutz-Suren: Zuflucht bei Allah suchen vor dem Bösen der Schöpfung, der Einflüsterung und des Neides." },
  ],
  en: [
    { day: 1, text: "Read Surah Al-Fatiha today and reflect on its meaning.", source: "Surah 1:1-7", tafsir: "Al-Fatiha is the essence of the entire Quran – a conversation between the servant and Allah, asking for guidance." },
    { day: 2, text: "Read Surah Al-Baqarah (verses 183-186) today – the verses about fasting in Ramadan.", source: "Surah 2:183-186", tafsir: "In these verses, Allah prescribes fasting and explains its purpose: so that you may attain Taqwa (God-consciousness)." },
    { day: 3, text: "Listen to Quran recitation for at least 10 minutes today.", source: "Surah 7:204", tafsir: "Allah commands us to listen to the Quran attentively and be silent, so that mercy may be granted to us." },
    { day: 4, text: "Read Ayat al-Kursi today and reflect on Allah's power.", source: "Surah 2:255", tafsir: "The most powerful verse in the Quran describes Allah's absolute sovereignty – His Throne encompasses the heavens and earth." },
    { day: 5, text: "Read Surah Al-Ikhlas three times and reflect.", source: "Surah 112:1-4", tafsir: "This short Surah equals one-third of the Quran – it summarizes pure monotheism (Tawhid) in four verses." },
    { day: 6, text: "Read the last 10 verses of Surah Al-Baqarah today.", source: "Surah 2:284-286", tafsir: "Allah does not burden a soul beyond its capacity – these verses are a protection when recited at night." },
    { day: 7, text: "Read Surah Yasin and ask Allah for understanding.", source: "Surah 36:1-12", tafsir: "Called the heart of the Quran, Yasin speaks of resurrection and Allah's signs in creation." },
    { day: 8, text: "Read Surah Ar-Rahman and count Allah's blessings.", source: "Surah 55:1-16", tafsir: "Allah lists His countless blessings and repeatedly asks: Which of the favors of your Lord will you deny?" },
    { day: 9, text: "Read Surah Al-Mulk before sleeping tonight.", source: "Surah 67:1-10", tafsir: "The Prophet ﷺ recommended this Surah before sleep – it protects from the punishment of the grave." },
    { day: 10, text: "Read Surah Al-Kahf and reflect on its stories.", source: "Surah 18:1-10", tafsir: "The story of the cave companions teaches that Allah protects those who sacrifice everything for their faith." },
    { day: 11, text: "Read one Juz (part) of the Quran today.", source: "Surah 2:185", tafsir: "Ramadan is the month in which the Quran was revealed – as guidance and clear proofs for mankind." },
    { day: 12, text: "Read Surah Maryam and think about patience.", source: "Surah 19:1-15", tafsir: "The story of Zakariya shows: even when a prayer seems impossible, Allah answers the sincere supplication." },
    { day: 13, text: "Read the story of Prophet Yusuf (verses 1-20).", source: "Surah 12:1-20", tafsir: "The best of all stories teaches that behind every trial lies Allah's wise plan." },
    { day: 14, text: "Read Surah Al-Waqiah for Rizq and blessings.", source: "Surah 56:1-20", tafsir: "The Prophet ﷺ said whoever recites Al-Waqiah every night will never suffer poverty." },
    { day: 15, text: "Read Surah Ad-Dukhan and ask for protection.", source: "Surah 44:1-16", tafsir: "This Surah was revealed on a blessed night and warns of the consequences of rejecting the truth." },
    { day: 16, text: "Read the verses about patience in Surah Al-Baqarah.", source: "Surah 2:153-157", tafsir: "Allah is with the patient – and upon those who remain steadfast in trials come blessings and mercy." },
    { day: 17, text: "Read Surah Al-Anfal and think about Tawakkul.", source: "Surah 8:1-10", tafsir: "True reliance on Allah (Tawakkul) means fully trusting Him – and He is sufficient as a Protector." },
    { day: 18, text: "Read Surah At-Tawbah (verses 1-20).", source: "Surah 9:1-20", tafsir: "Tawbah means turning back – Allah loves those who sincerely repent and return to Him." },
    { day: 19, text: "Read Surah Hud and the stories of the Prophets.", source: "Surah 11:1-20", tafsir: "Every prophet faced seemingly hopeless situations – yet Allah's help always came at the right time." },
    { day: 20, text: "Read Surah Ar-Ra'd and think about Allah's signs.", source: "Surah 13:1-15", tafsir: "Even the thunder glorifies Allah – every element of creation is a sign for those who reflect." },
    { day: 21, text: "Read Surah Al-Qadr and ask for Laylatul Qadr.", source: "Surah 97:1-5", tafsir: "The Night of Decree is better than a thousand months – the angels descend by Allah's permission." },
    { day: 22, text: "Read as much Quran as possible - tonight might be Laylatul Qadr.", source: "Surah 97:3", tafsir: "Seek this night in the last ten nights – a single night of worship outweighs 83 years." },
    { day: 23, text: "Read Surah Al-Fajr and think about the Day of Judgment.", source: "Surah 89:1-14", tafsir: "Allah swears by the dawn – a warning against clinging to worldly possessions instead of Him." },
    { day: 24, text: "Read Surah Ash-Shams and reflect on the soul.", source: "Surah 91:1-10", tafsir: "Successful is the one who purifies their soul – and lost is the one who corrupts it with sin." },
    { day: 25, text: "Read Surah Al-Lail and Al-Duha today.", source: "Surah 92:1-21, 93:1-11", tafsir: "Whoever gives and is God-fearing, Allah eases the path – and after every hardship comes relief." },
    { day: 26, text: "Read Surah At-Tin and Al-Alaq today.", source: "Surah 95:1-8, 96:1-5", tafsir: "Humanity was created in the best form – and the first word of revelation was: Read!" },
    { day: 27, text: "Read Quran intensively - this might be Laylatul Qadr!", source: "Surah 97:1-5", tafsir: "The Prophet ﷺ sought Laylatul Qadr especially on odd nights – the 27th night is the most likely." },
    { day: 28, text: "Read Surah Al-Bayyinah and Al-Zilzal today.", source: "Surah 98:1-8, 99:1-8", tafsir: "Every atom of good and every atom of evil will be visible on the Day of Judgment – nothing remains hidden." },
    { day: 29, text: "Read Surah Al-Asr and reflect on time.", source: "Surah 103:1-3", tafsir: "The Quran's shortest warning: mankind is in loss – except those who believe and practice patience." },
    { day: 30, text: "End Ramadan by reading Surah An-Nas, Al-Falaq and Al-Ikhlas.", source: "Surah 112-114", tafsir: "The three protective Surahs: seeking refuge in Allah from the evil of creation, whispers, and envy." },
  ],
  bs: [
    { day: 1, text: "Danas pročitaj Suru El-Fatiha i razmisli o njenom značenju.", source: "Sura 1:1-7", tafsir: "El-Fatiha je suština cijelog Kur'ana – razgovor između roba i Allaha, u kojem molimo za uputu." },
    { day: 2, text: "Danas pročitaj Suru El-Bekare (ajeti 183-186) – ajeti o postu u Ramazanu.", source: "Sura 2:183-186", tafsir: "U ovim ajetima Allah propisuje post i objašnjava njegov cilj: da biste postigli takvaluk (bogobojaznost)." },
    { day: 3, text: "Danas slušaj učenje Kur'ana najmanje 10 minuta.", source: "Sura 7:204", tafsir: "Allah naređuje da pažljivo slušamo Kur'an i šutimo, kako bismo zaslužili milost." },
    { day: 4, text: "Danas pročitaj Ajetul-Kursi i razmisli o Allahovoj moći.", source: "Sura 2:255", tafsir: "Najmoćniji ajet Kur'ana opisuje Allahovu apsolutnu vlast – Njegov Arš obuhvata nebesa i Zemlju." },
    { day: 5, text: "Danas prouči Suru El-Ihlas tri puta i razmisli.", source: "Sura 112:1-4", tafsir: "Ova kratka sura je jednaka trećini Kur'ana – sažima čisti tevhid (monoteizam) u četiri ajeta." },
    { day: 6, text: "Danas pročitaj zadnjih 10 ajeta Sure El-Bekare.", source: "Sura 2:284-286", tafsir: "Allah ne opterećuje dušu preko njene mogućnosti – ovi ajeti su zaštita kada se uče noću." },
    { day: 7, text: "Danas pročitaj Suru Jasin i zamoli Allaha za razumijevanje.", source: "Sura 36:1-12", tafsir: "Nazvana srcem Kur'ana, Jasin govori o proživljenju i Allahovim znakovima u stvaranju." },
    { day: 8, text: "Danas pročitaj Suru Er-Rahman i izbroji Allahove blagodati.", source: "Sura 55:1-16", tafsir: "Allah nabraja Svoje nebrojene blagodati i ponavlja: Koju blagodat Gospodara svoga poričete?" },
    { day: 9, text: "Večeras pročitaj Suru El-Mulk prije spavanja.", source: "Sura 67:1-10", tafsir: "Poslanik ﷺ je preporučio ovu suru prije spavanja – ona štiti od kaburske kazne." },
    { day: 10, text: "Danas pročitaj Suru El-Kehf i razmisli o pričama.", source: "Sura 18:1-10", tafsir: "Priča o stanovnicima pećine uči da Allah štiti one koji žrtvuju sve zarad svog imana." },
    { day: 11, text: "Danas pročitaj jedan džuz Kur'ana.", source: "Sura 2:185", tafsir: "Ramazan je mjesec u kojem je objavljen Kur'an – kao uputa i jasni dokazi za ljude." },
    { day: 12, text: "Danas pročitaj Suru Merjem i razmisli o strpljenju.", source: "Sura 19:1-15", tafsir: "Priča o Zekerijja a.s. pokazuje: čak i kad se dova čini nemogućom, Allah odgovara iskrenom robu." },
    { day: 13, text: "Danas pročitaj priču o Jusufu a.s. (ajeti 1-20).", source: "Sura 12:1-20", tafsir: "Najljepša priča uči da iza svake kušnje stoji Allahov mudri plan." },
    { day: 14, text: "Danas pročitaj Suru El-Vakia za nafaku i bereket.", source: "Sura 56:1-20", tafsir: "Poslanik ﷺ je rekao da ko uči El-Vakiu svaku noć, nikada neće doživjeti siromaštvo." },
    { day: 15, text: "Danas pročitaj Suru Ed-Duhan i zamoli za zaštitu.", source: "Sura 44:1-16", tafsir: "Ova sura je objavljena u blagoslovljenoj noći i upozorava na posljedice odbijanja istine." },
    { day: 16, text: "Danas pročitaj ajete o strpljenju u Suri El-Bekare.", source: "Sura 2:153-157", tafsir: "Allah je sa strpljivima – a one koji budu ustrajni u iskušenjima čekaju blagoslov i milost." },
    { day: 17, text: "Danas pročitaj Suru El-Enfal i razmisli o tevekkulu.", source: "Sura 8:1-10", tafsir: "Istinski tevekkul znači potpuno oslanjanje na Allaha – a On je dovoljan kao Zaštitnik." },
    { day: 18, text: "Danas pročitaj Suru Et-Tevbe (ajeti 1-20).", source: "Sura 9:1-20", tafsir: "Tevba znači povratak – Allah voli one koji se iskreno pokaju i Njemu vrate." },
    { day: 19, text: "Danas pročitaj Suru Hud i priče o poslanicima.", source: "Sura 11:1-20", tafsir: "Svaki poslanik se suočio sa naizgled beznadežnim situacijama – ali Allahova pomoć je uvijek stigla na vrijeme." },
    { day: 20, text: "Danas pročitaj Suru Er-Ra'd i razmisli o Allahovim znakovima.", source: "Sura 13:1-15", tafsir: "Čak i grom slavi Allaha – svaki element stvaranja je znak za one koji razmišljaju." },
    { day: 21, text: "Danas pročitaj Suru El-Kadr i moli za Lejletul-kadr.", source: "Sura 97:1-5", tafsir: "Noć određenja je bolja od hiljadu mjeseci – u njoj se meleki spuštaju s Allahovim dopuštenjem." },
    { day: 22, text: "Danas uči što više Kur'ana - ova noć bi mogla biti Lejletul-kadr.", source: "Sura 97:3", tafsir: "Traži ovu noć u zadnjih deset noći – jedna noć ibadeta teža je od 83 godine." },
    { day: 23, text: "Danas pročitaj Suru El-Fedžr i razmisli o Sudnjem danu.", source: "Sura 89:1-14", tafsir: "Allah se kune zorom – upozorenje na privrženost dunjaluku umjesto Njemu." },
    { day: 24, text: "Danas pročitaj Suru Eš-Šems i razmisli o duši.", source: "Sura 91:1-10", tafsir: "Uspio je ko dušu očisti – a propao je ko je grijehom uprlja." },
    { day: 25, text: "Danas pročitaj Sure El-Lejl i Ed-Duha.", source: "Sura 92:1-21, 93:1-11", tafsir: "Ko daje i bogobojazan je, Allah mu olakša put – a poslije svake teškoće dolazi olakšanje." },
    { day: 26, text: "Danas pročitaj Sure Et-Tin i El-Alek.", source: "Sura 95:1-8, 96:1-5", tafsir: "Čovjek je stvoren u najljepšem obliku – a prva riječ objave bila je: Uči!" },
    { day: 27, text: "Danas intenzivno uči Kur'an - ovo bi mogla biti Lejletul-kadr!", source: "Sura 97:1-5", tafsir: "Poslanik ﷺ je tražio Lejletul-kadr posebno u neparnim noćima – 27. noć je najvjerovatnija." },
    { day: 28, text: "Danas pročitaj Sure El-Bejjine i Ez-Zilzal.", source: "Sura 98:1-8, 99:1-8", tafsir: "Svaki atom dobra i svaki atom zla bit će vidljiv na Sudnjem danu – ništa ne ostaje skriveno." },
    { day: 29, text: "Danas pročitaj Suru El-Asr i razmisli o vremenu.", source: "Sura 103:1-3", tafsir: "Najkraće upozorenje Kur'ana: čovjek je na gubitku – osim onih koji vjeruju i strpljivi su." },
    { day: 30, text: "Završi Ramazan učenjem Sura En-Nas, El-Felek i El-Ihlas.", source: "Sura 112-114", tafsir: "Tri zaštitne sure: traženje utočišta kod Allaha od zla stvorenja, došaptavanja i zavisti." },
  ],
  ar: [
    { day: 1, text: "اقرأ سورة الفاتحة اليوم وتأمل في معانيها.", source: "سورة 1:1-7", tafsir: "الفاتحة هي أم القرآن – حوار بين العبد وربه، نسأل فيه الهداية إلى الصراط المستقيم." },
    { day: 2, text: "اقرأ اليوم سورة البقرة (الآيات ١٨٣-١٨٦) – آيات الصيام في رمضان.", source: "سورة البقرة ٢:١٨٣-١٨٦", tafsir: "في هذه الآيات فرض الله الصيام وبيّن حكمته: لعلكم تتقون." },
    { day: 3, text: "استمع إلى تلاوة القرآن لمدة 10 دقائق على الأقل اليوم.", source: "سورة 7:204", tafsir: "أمر الله بالإنصات عند تلاوة القرآن والسكوت، رجاء الرحمة." },
    { day: 4, text: "اقرأ آية الكرسي اليوم وتأمل في قدرة الله.", source: "سورة 2:255", tafsir: "أعظم آية في القرآن تصف سلطان الله المطلق – كرسيه وسع السماوات والأرض." },
    { day: 5, text: "اقرأ سورة الإخلاص ثلاث مرات وتأمل.", source: "سورة 112:1-4", tafsir: "سورة قصيرة تعدل ثلث القرآن – تلخّص التوحيد الخالص في أربع آيات." },
    { day: 6, text: "اقرأ آخر 10 آيات من سورة البقرة اليوم.", source: "سورة 2:284-286", tafsir: "لا يكلف الله نفساً إلا وسعها – هذه الآيات حرز لمن قرأها ليلاً." },
    { day: 7, text: "اقرأ سورة يس واسأل الله الفهم.", source: "سورة 36:1-12", tafsir: "تُسمى قلب القرآن – تتحدث عن البعث وآيات الله في الخلق." },
    { day: 8, text: "اقرأ سورة الرحمن وعدّ نعم الله.", source: "سورة 55:1-16", tafsir: "يعدّد الله نعمه التي لا تُحصى ويكرر: فبأيّ آلاء ربكما تكذّبان؟" },
    { day: 9, text: "اقرأ سورة الملك قبل النوم الليلة.", source: "سورة 67:1-10", tafsir: "أوصى النبي ﷺ بقراءتها قبل النوم – فهي تقي من عذاب القبر." },
    { day: 10, text: "اقرأ سورة الكهف وتأمل في قصصها.", source: "سورة 18:1-10", tafsir: "قصة أصحاب الكهف تعلّم أن الله يحمي من يضحّي بكل شيء من أجل إيمانه." },
    { day: 11, text: "اقرأ جزءاً واحداً من القرآن اليوم.", source: "سورة 2:185", tafsir: "شهر رمضان الذي أُنزل فيه القرآن هدى للناس وبيّنات من الهدى والفرقان." },
    { day: 12, text: "اقرأ سورة مريم وفكر في الصبر.", source: "سورة 19:1-15", tafsir: "قصة زكريا تُظهر: حتى لو بدا الدعاء مستحيلاً، يستجيب الله للداعي المخلص." },
    { day: 13, text: "اقرأ قصة يوسف عليه السلام (الآيات 1-20).", source: "سورة 12:1-20", tafsir: "أحسن القصص تعلّم أن وراء كل ابتلاء حكمة إلهية." },
    { day: 14, text: "اقرأ سورة الواقعة للرزق والبركة.", source: "سورة 56:1-20", tafsir: "قال النبي ﷺ من قرأ الواقعة كل ليلة لم تصبه فاقة أبداً." },
    { day: 15, text: "اقرأ سورة الدخان واسأل الحماية.", source: "سورة 44:1-16", tafsir: "نزلت في ليلة مباركة وتحذّر من عاقبة رفض الحق." },
    { day: 16, text: "اقرأ آيات الصبر في سورة البقرة.", source: "سورة 2:153-157", tafsir: "إن الله مع الصابرين – والذين يصبرون في البلاء لهم صلوات من ربهم ورحمة." },
    { day: 17, text: "اقرأ سورة الأنفال وفكر في التوكل.", source: "سورة 8:1-10", tafsir: "التوكل الحقيقي هو الاعتماد الكامل على الله – وكفى به وكيلاً." },
    { day: 18, text: "اقرأ سورة التوبة (الآيات 1-20).", source: "سورة 9:1-20", tafsir: "التوبة تعني العودة – والله يحب التوابين المتطهرين." },
    { day: 19, text: "اقرأ سورة هود وقصص الأنبياء.", source: "سورة 11:1-20", tafsir: "كل نبي واجه ظروفاً بدت ميؤوساً منها – لكن نصر الله جاء دائماً في الوقت المناسب." },
    { day: 20, text: "اقرأ سورة الرعد وفكر في آيات الله.", source: "سورة 13:1-15", tafsir: "حتى الرعد يسبّح بحمد الله – كل عنصر في الخلق آية لمن يتفكر." },
    { day: 21, text: "اقرأ سورة القدر وادعُ لليلة القدر.", source: "سورة 97:1-5", tafsir: "ليلة القدر خير من ألف شهر – تتنزل الملائكة فيها بإذن ربهم." },
    { day: 22, text: "اقرأ أكبر قدر من القرآن - قد تكون هذه ليلة القدر.", source: "سورة 97:3", tafsir: "التمسوها في العشر الأواخر – ليلة واحدة من العبادة خير من ٨٣ سنة." },
    { day: 23, text: "اقرأ سورة الفجر وفكر في يوم القيامة.", source: "سورة 89:1-14", tafsir: "يقسم الله بالفجر – تحذير من التعلق بالدنيا بدلاً من طاعته." },
    { day: 24, text: "اقرأ سورة الشمس وتأمل في النفس.", source: "سورة 91:1-10", tafsir: "قد أفلح من زكّاها وقد خاب من دسّاها." },
    { day: 25, text: "اقرأ سورة الليل والضحى اليوم.", source: "سورة 92:1-21، 93:1-11", tafsir: "من أعطى واتقى يسّره الله لليسرى – وبعد كل عسر يسر." },
    { day: 26, text: "اقرأ سورة التين والعلق اليوم.", source: "سورة 95:1-8، 96:1-5", tafsir: "خُلق الإنسان في أحسن تقويم – وأول كلمة نزلت: اقرأ!" },
    { day: 27, text: "اقرأ القرآن بكثافة - قد تكون هذه ليلة القدر!", source: "سورة 97:1-5", tafsir: "كان النبي ﷺ يتحرّى ليلة القدر في الأوتار – والليلة السابعة والعشرون أرجاها." },
    { day: 28, text: "اقرأ سورة البينة والزلزلة اليوم.", source: "سورة 98:1-8، 99:1-8", tafsir: "كل ذرة خير وكل ذرة شر ستُرى يوم القيامة – لا شيء يبقى مخفياً." },
    { day: 29, text: "اقرأ سورة العصر وتأمل في الوقت.", source: "سورة 103:1-3", tafsir: "أقصر تحذير في القرآن: الإنسان في خسر إلا من آمن وتواصى بالصبر." },
    { day: 30, text: "اختم رمضان بقراءة سورة الناس والفلق والإخلاص.", source: "سورة 112-114", tafsir: "المعوّذات الثلاث: الاستعاذة بالله من شر الخلق والوسوسة والحسد." },
  ],
  id: [
    { day: 1, text: "Baca Surah Al-Fatihah hari ini dan renungkan maknanya.", source: "Surah 1:1-7", tafsir: "Al-Fatihah adalah intisari seluruh Al-Quran – dialog antara hamba dan Allah, memohon petunjuk." },
    { day: 2, text: "Baca Surah Al-Baqarah (ayat 183-186) hari ini – ayat tentang puasa Ramadan.", source: "Surah 2:183-186", tafsir: "Dalam ayat ini Allah mewajibkan puasa dan menjelaskan tujuannya: agar kalian bertakwa." },
    { day: 3, text: "Dengarkan tilawah Al-Quran minimal 10 menit hari ini.", source: "Surah 7:204", tafsir: "Allah memerintahkan untuk mendengarkan Al-Quran dengan penuh perhatian agar mendapat rahmat." },
    { day: 4, text: "Baca Ayat Kursi hari ini dan renungkan kekuasaan Allah.", source: "Surah 2:255", tafsir: "Ayat paling agung dalam Al-Quran menggambarkan kedaulatan mutlak Allah – Kursi-Nya meliputi langit dan bumi." },
    { day: 5, text: "Baca Surah Al-Ikhlas tiga kali dan renungkan.", source: "Surah 112:1-4", tafsir: "Surah pendek ini setara sepertiga Al-Quran – merangkum tauhid murni dalam empat ayat." },
    { day: 6, text: "Baca 10 ayat terakhir Surah Al-Baqarah hari ini.", source: "Surah 2:284-286", tafsir: "Allah tidak membebani jiwa melebihi kemampuannya – ayat-ayat ini menjadi perlindungan di malam hari." },
    { day: 7, text: "Baca Surah Yasin dan minta pemahaman dari Allah.", source: "Surah 36:1-12", tafsir: "Disebut jantung Al-Quran, Yasin berbicara tentang kebangkitan dan tanda-tanda Allah dalam ciptaan." },
    { day: 8, text: "Baca Surah Ar-Rahman dan hitung nikmat Allah.", source: "Surah 55:1-16", tafsir: "Allah menyebutkan nikmat-Nya yang tak terhitung dan berulang kali bertanya: Nikmat Tuhanmu yang mana yang kamu dustakan?" },
    { day: 9, text: "Baca Surah Al-Mulk sebelum tidur malam ini.", source: "Surah 67:1-10", tafsir: "Nabi ﷺ menganjurkan membaca surah ini sebelum tidur – ia melindungi dari siksa kubur." },
    { day: 10, text: "Baca Surah Al-Kahfi dan renungkan kisah-kisahnya.", source: "Surah 18:1-10", tafsir: "Kisah Ashabul Kahfi mengajarkan bahwa Allah melindungi mereka yang berkorban demi iman." },
    { day: 11, text: "Baca satu juz Al-Quran hari ini.", source: "Surah 2:185", tafsir: "Ramadan adalah bulan diturunkannya Al-Quran – sebagai petunjuk dan bukti nyata bagi manusia." },
    { day: 12, text: "Baca Surah Maryam dan pikirkan tentang kesabaran.", source: "Surah 19:1-15", tafsir: "Kisah Zakariya menunjukkan: meskipun doa tampak mustahil, Allah menjawab hamba yang tulus." },
    { day: 13, text: "Baca kisah Nabi Yusuf (ayat 1-20).", source: "Surah 12:1-20", tafsir: "Kisah terbaik mengajarkan bahwa di balik setiap ujian tersimpan rencana bijak Allah." },
    { day: 14, text: "Baca Surah Al-Waqiah untuk rezeki dan berkah.", source: "Surah 56:1-20", tafsir: "Nabi ﷺ bersabda, siapa yang membaca Al-Waqiah setiap malam tidak akan pernah miskin." },
    { day: 15, text: "Baca Surah Ad-Dukhan dan minta perlindungan.", source: "Surah 44:1-16", tafsir: "Surah ini diturunkan pada malam yang diberkahi dan memperingatkan akibat menolak kebenaran." },
    { day: 16, text: "Baca ayat-ayat tentang kesabaran di Surah Al-Baqarah.", source: "Surah 2:153-157", tafsir: "Allah bersama orang-orang yang sabar – mereka yang tabah dalam ujian akan mendapat berkat dan rahmat." },
    { day: 17, text: "Baca Surah Al-Anfal dan pikirkan tentang tawakkal.", source: "Surah 8:1-10", tafsir: "Tawakkal sejati berarti sepenuhnya berserah kepada Allah – dan cukuplah Dia sebagai Pelindung." },
    { day: 18, text: "Baca Surah At-Taubah (ayat 1-20).", source: "Surah 9:1-20", tafsir: "Taubat berarti kembali – Allah mencintai mereka yang bertaubat dengan tulus dan kembali kepada-Nya." },
    { day: 19, text: "Baca Surah Hud dan kisah-kisah para nabi.", source: "Surah 11:1-20", tafsir: "Setiap nabi menghadapi situasi yang tampak tanpa harapan – namun pertolongan Allah selalu datang tepat waktu." },
    { day: 20, text: "Baca Surah Ar-Ra'd dan pikirkan tanda-tanda Allah.", source: "Surah 13:1-15", tafsir: "Bahkan petir pun bertasbih memuji Allah – setiap elemen ciptaan adalah tanda bagi yang merenungkan." },
    { day: 21, text: "Baca Surah Al-Qadr dan berdoa untuk Lailatul Qadr.", source: "Surah 97:1-5", tafsir: "Malam Kemuliaan lebih baik dari seribu bulan – para malaikat turun dengan izin Allah." },
    { day: 22, text: "Baca sebanyak mungkin Al-Quran - malam ini mungkin Lailatul Qadr.", source: "Surah 97:3", tafsir: "Carilah malam ini di sepuluh malam terakhir – satu malam ibadah melebihi 83 tahun." },
    { day: 23, text: "Baca Surah Al-Fajr dan pikirkan Hari Kiamat.", source: "Surah 89:1-14", tafsir: "Allah bersumpah demi fajar – peringatan agar tidak terpaut pada harta dunia." },
    { day: 24, text: "Baca Surah Ash-Shams dan renungkan jiwa.", source: "Surah 91:1-10", tafsir: "Beruntung orang yang menyucikan jiwanya – dan rugi orang yang mengotorinya dengan dosa." },
    { day: 25, text: "Baca Surah Al-Lail dan Ad-Dhuha hari ini.", source: "Surah 92:1-21, 93:1-11", tafsir: "Siapa yang memberi dan bertakwa, Allah mudahkan jalannya – dan setelah kesulitan pasti ada kemudahan." },
    { day: 26, text: "Baca Surah At-Tin dan Al-Alaq hari ini.", source: "Surah 95:1-8, 96:1-5", tafsir: "Manusia diciptakan dalam bentuk sebaik-baiknya – dan kata pertama wahyu adalah: Bacalah!" },
    { day: 27, text: "Baca Al-Quran dengan intensif - ini mungkin Lailatul Qadr!", source: "Surah 97:1-5", tafsir: "Nabi ﷺ mencari Lailatul Qadr terutama di malam ganjil – malam ke-27 paling diharapkan." },
    { day: 28, text: "Baca Surah Al-Bayyinah dan Al-Zalzalah hari ini.", source: "Surah 98:1-8, 99:1-8", tafsir: "Setiap atom kebaikan dan keburukan akan terlihat di Hari Kiamat – tidak ada yang tersembunyi." },
    { day: 29, text: "Baca Surah Al-Asr dan renungkan waktu.", source: "Surah 103:1-3", tafsir: "Peringatan terpendek dalam Al-Quran: manusia dalam kerugian kecuali yang beriman dan bersabar." },
    { day: 30, text: "Akhiri Ramadan dengan membaca Surah An-Nas, Al-Falaq dan Al-Ikhlas.", source: "Surah 112-114", tafsir: "Tiga surah pelindung: berlindung kepada Allah dari kejahatan makhluk, bisikan, dan kedengkian." },
  ],
  tr: [
    { day: 1, text: "Bugün Fatiha Suresi'ni oku ve anlamı üzerinde düşün.", source: "Sure 1:1-7", tafsir: "Fatiha, Kur'an'ın özüdür – kul ile Allah arasında hidayet dilenen bir diyalog." },
    { day: 2, text: "Bugün Bakara Suresi'ni (183-186. ayetler) oku – Ramazan'da oruç hakkındaki ayetler.", source: "Sure 2:183-186", tafsir: "Bu ayetlerde Allah orucu farz kılmış ve amacını açıklamıştır: takva sahibi olmanız için." },
    { day: 3, text: "Bugün en az 10 dakika Kur'an dinle.", source: "Sure 7:204", tafsir: "Allah, Kur'an okunduğunda dikkatle dinlememizi ve susmamızı emreder – rahmet umulur." },
    { day: 4, text: "Bugün Ayetel Kürsi'yi oku ve Allah'ın kudreti üzerine düşün.", source: "Sure 2:255", tafsir: "Kur'an'ın en büyük ayeti, Allah'ın mutlak egemenliğini anlatır – Kürsüsü gökleri ve yeri kuşatır." },
    { day: 5, text: "Bugün İhlas Suresi'ni üç kez oku ve düşün.", source: "Sure 112:1-4", tafsir: "Bu kısa sure Kur'an'ın üçte birine denktir – saf tevhidi dört ayette özetler." },
    { day: 6, text: "Bugün Bakara Suresi'nin son 10 ayetini oku.", source: "Sure 2:284-286", tafsir: "Allah hiçbir nefse gücünün üstünde yük yüklemez – gece okunan bu ayetler korunmadır." },
    { day: 7, text: "Bugün Yasin Suresi'ni oku ve Allah'tan anlayış iste.", source: "Sure 36:1-12", tafsir: "Kur'an'ın kalbi olarak anılan Yasin, diriliş ve yaratılıştaki ilahi işaretleri anlatır." },
    { day: 8, text: "Bugün Rahman Suresi'ni oku ve Allah'ın nimetlerini say.", source: "Sure 55:1-16", tafsir: "Allah sayısız nimetlerini sıralar ve defalarca sorar: Rabbinizin nimetlerinden hangisini yalanlarsınız?" },
    { day: 9, text: "Bu gece uyumadan önce Mülk Suresi'ni oku.", source: "Sure 67:1-10", tafsir: "Hz. Peygamber ﷺ bu sureyi uyumadan önce tavsiye etmiştir – kabir azabından korur." },
    { day: 10, text: "Bugün Kehf Suresi'ni oku ve hikayelerini düşün.", source: "Sure 18:1-10", tafsir: "Ashab-ı Kehf kıssası, imanı uğruna her şeyden vazgeçenleri Allah'ın koruduğunu öğretir." },
    { day: 11, text: "Bugün bir cüz Kur'an oku.", source: "Sure 2:185", tafsir: "Ramazan, Kur'an'ın indirildiği aydır – insanlara hidayet ve apaçık deliller olarak." },
    { day: 12, text: "Bugün Meryem Suresi'ni oku ve sabır üzerine düşün.", source: "Sure 19:1-15", tafsir: "Zekeriya kıssası gösterir: dua imkansız görünse de Allah samimi kuluna icabet eder." },
    { day: 13, text: "Bugün Yusuf a.s.'ın kıssasını oku (ayet 1-20).", source: "Sure 12:1-20", tafsir: "Kıssaların en güzeli, her imtihanın ardında Allah'ın hikmetli planının olduğunu öğretir." },
    { day: 14, text: "Bugün rızık ve bereket için Vakıa Suresi'ni oku.", source: "Sure 56:1-20", tafsir: "Hz. Peygamber ﷺ buyurdu: Her gece Vakıa'yı okuyan asla fakirlik görmez." },
    { day: 15, text: "Bugün Duhan Suresi'ni oku ve koruma iste.", source: "Sure 44:1-16", tafsir: "Mübarek bir gecede indirilen bu sure, hakkı reddetmenin sonuçlarını hatırlatır." },
    { day: 16, text: "Bugün Bakara Suresi'ndeki sabır ayetlerini oku.", source: "Sure 2:153-157", tafsir: "Allah sabredenlerle beraberdir – imtihanlarda direnenler için Rablerinden bereket ve rahmet vardır." },
    { day: 17, text: "Bugün Enfal Suresi'ni oku ve tevekkül üzerine düşün.", source: "Sure 8:1-10", tafsir: "Gerçek tevekkül, tam anlamıyla Allah'a güvenmektir – O, Vekil olarak yeter." },
    { day: 18, text: "Bugün Tevbe Suresi'ni oku (ayet 1-20).", source: "Sure 9:1-20", tafsir: "Tevbe, dönüş demektir – Allah samimiyetle tövbe edip dönen kullarını sever." },
    { day: 19, text: "Bugün Hud Suresi'ni ve peygamber kıssalarını oku.", source: "Sure 11:1-20", tafsir: "Her peygamber umutsuz görünen durumlarla karşılaştı – ama Allah'ın yardımı hep zamanında geldi." },
    { day: 20, text: "Bugün Ra'd Suresi'ni oku ve Allah'ın ayetlerini düşün.", source: "Sure 13:1-15", tafsir: "Gök gürültüsü bile Allah'ı tesbih eder – yaratılışın her unsuru düşünenler için bir ayettir." },
    { day: 21, text: "Bugün Kadir Suresi'ni oku ve Kadir Gecesi için dua et.", source: "Sure 97:1-5", tafsir: "Kadir Gecesi bin aydan hayırlıdır – melekler Rablerinin izniyle iner." },
    { day: 22, text: "Bugün mümkün olduğunca çok Kur'an oku - bu gece Kadir Gecesi olabilir.", source: "Sure 97:3", tafsir: "Son on gecede bu geceyi ara – bir gece ibadeti 83 yıldan değerlidir." },
    { day: 23, text: "Bugün Fecr Suresi'ni oku ve Kıyamet Günü'nü düşün.", source: "Sure 89:1-14", tafsir: "Allah fecre yemin eder – dünya malına bağlanmak yerine O'na yönelmenin uyarısı." },
    { day: 24, text: "Bugün Şems Suresi'ni oku ve nefis üzerine düşün.", source: "Sure 91:1-10", tafsir: "Nefsini arındıran kurtuluşa erdi – onu günahla kirletenler ise hüsrana uğradı." },
    { day: 25, text: "Bugün Leyl ve Duha Surelerini oku.", source: "Sure 92:1-21, 93:1-11", tafsir: "Kim verir ve takva sahibi olursa, Allah ona kolay yolu kolaylaştırır – her zorluktan sonra kolaylık gelir." },
    { day: 26, text: "Bugün Tin ve Alak Surelerini oku.", source: "Sure 95:1-8, 96:1-5", tafsir: "İnsan en güzel biçimde yaratıldı – vahyin ilk sözü: Oku!" },
    { day: 27, text: "Bugün yoğun şekilde Kur'an oku - bu Kadir Gecesi olabilir!", source: "Sure 97:1-5", tafsir: "Hz. Peygamber ﷺ Kadir Gecesi'ni özellikle tek gecelerde aradı – 27. gece en muhtemeldir." },
    { day: 28, text: "Bugün Beyyine ve Zilzal Surelerini oku.", source: "Sure 98:1-8, 99:1-8", tafsir: "Zerre miktarı hayır ve zerre miktarı şer Kıyamet'te görülecek – hiçbir şey gizli kalmaz." },
    { day: 29, text: "Bugün Asr Suresi'ni oku ve zaman üzerine düşün.", source: "Sure 103:1-3", tafsir: "Kur'an'ın en kısa uyarısı: İnsan hüsrandadır – iman edip sabredenler hariç." },
    { day: 30, text: "Ramazan'ı Nas, Felak ve İhlas Surelerini okuyarak bitir.", source: "Sure 112-114", tafsir: "Üç koruyucu sure: Yaratılmışların, vesvesecilerin ve hasetçilerin şerrinden Allah'a sığınmak." },
  ],
};

// Language configuration
export const languages = [
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'bs', name: 'Bosanski', flag: '🇧🇦' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦', rtl: true },
  { code: 'id', name: 'Indonesia', flag: '🇮🇩' },
  { code: 'tr', name: 'Türkçe', flag: '🇹🇷' }
];

// Date format locales
export const dateLocales = {
  de: 'de-DE',
  en: 'en-GB',
  bs: 'hr-HR',
  ar: 'ar-SA',
  id: 'id-ID',
  tr: 'tr-TR'
};

// Bosnian month names (manual fallback)
export const bosnianMonths = {
  long: ['januar', 'februar', 'mart', 'april', 'maj', 'juni', 'juli', 'august', 'septembar', 'oktobar', 'novembar', 'decembar'],
  short: ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec']
};

export const bosnianWeekdays = {
  long: ['nedjelja', 'ponedjeljak', 'utorak', 'srijeda', 'četvrtak', 'petak', 'subota'],
  short: ['ned', 'pon', 'uto', 'sri', 'čet', 'pet', 'sub']
};
